
<!-- Layers tab-->
<div class="fdm-sidebar-toolbar fdm-buttons clearfix">

  

  <!-- Add new layer -->
  <button class="fdm-linked pointer fdm-tools-button fdm-tools-button-accent float-left" 
    (click)="clickAddData()"
    [matTooltip]="'PROJECT.DIALOG.ADD_LAYER' | translate"
    id="add-layer">
    <fa-icon [icon]="['far','layer-plus']"></fa-icon>
  </button>

  <!-- Player -->
  <!-- <button class="fdm-linked pointer fdm-tools-button float-left" 
    [matTooltip]="'PROJECT.DIALOG.PLAYER' | translate" 
    [class.fdm-is-on]="mapComponent?.isPlaying"
    (click)="changeOpacityAllTransform()"
    id="play-layer">
    <fa-icon [icon]="['far','play']"></fa-icon>
  </button> -->

  <!-- info -->
  <!-- <button class="fdm-linked pointer fdm-tools-button float-left" 
    [matTooltip]="'INSPECTOR.NAME' | translate" 
    [routerLink]="['featureProperties']"
    id="play-layer">
    <fa-icon icon="info"></fa-icon>
  </button> -->

  <!-- Split view-->
  <ng-container *ngIf="splitViewer">
    <button class="fdm-linked pointer fdm-tools-button float-left"
      [class.fdm-is-on]="splitViewer.isSplitting"
      [hidden]="!splitViewer.canSplit"
      [disabled]="!splitViewer.canSplit"
      (click)="toggleSplitView()"
      [matTooltip]="'PROJECT.DIALOG.SPLIT_VIEW' | translate"
      id="split-layer">
      <fa-icon [icon]="['far','columns']"></fa-icon>
    </button>
  </ng-container>

  <ng-container *ngIf="tileProfiler">
    <button class="fdm-linked pointer fdm-tools-button float-left" [class.fdm-is-on]="tileProfiler.profilerActive" id="tile-profiler" matTooltip="Tile Profiler" (click)="toggleTileProfiler()">
      <fa-icon [icon]="['far', 'bread-loaf']"></fa-icon>
    </button>
  </ng-container>

      <!-- Delete layer -->
      <!-- <button class="fdm-linked pointer fdm-tools-button float-left" 
      (click)="editing = !editing" 
      *ngIf="mapService.scene && permissions?.can?.delete?.layer" 
      id="delete-layer"
      [matTooltip]="'PROJECT.DIALOG.REMOVE_LAYER' | translate">
      <fa-icon [icon]="['far','trash']"></fa-icon>
    </button> -->

    <!-- SCENE OPTIONS relocated to sit with rest of scene heading -->

    <!-- Rename scene -->
 <!-- <mat-menu #menu="matMenu" [overlapTrigger]="false">
    <button mat-menu-item (click)="renameScene(mapService.scene)" *ngIf="permissions?.can?.rename?.scene">
      <mat-icon>edit</mat-icon>
      <span>{{ 'TOOLBAR.EDIT_NAME' | translate }}</span>
    </button>
    <mat-divider></mat-divider>
  -->

    <!-- Set scene camera view -->
    <!-- <ng-container *ngIf="mapService && mapService.currentProject && mapService.scene">
      <button mat-menu-item (click)="setSceneCameraView()">
        <fa-icon icon="camera" style="font-size:26px;margin-right:16px;opacity:0.54;"></fa-icon>
        <span>{{ 'TOOLBAR.CAMERA_VIEW' | translate }}</span>
      </button>

      -->

      <!-- Set scene as default -->
      <!-- <button mat-menu-item (click)="setSceneAsDefault()" *ngIf="mapService.scene.id != mapService.currentProject['lastActiveScene']">
        <fa-icon icon="check-square" style="font-size:26px;margin-right:16px;opacity:0.54;"></fa-icon>
        <span>{{ 'TOOLBAR.SET_DEFAULT' | translate }}</span>
      </button>

    -->

      <!-- Default scene -->
      <!-- <button mat-menu-item disabled *ngIf="mapService.scene.id == mapService.currentProject['lastActiveScene']">
        <fa-icon icon="check-square" style="font-size:26px;margin-right:16px;color:rgb(207, 233, 207)"></fa-icon>
        <span>{{ 'TOOLBAR.IS_DEFAULT' | translate }}</span>
      </button>
    </ng-container>
  -->
    <!--
    <button mat-menu-item (click)="editing = !editing" *ngIf="mapService.scene && permissions?.can?.delete?.layer">
      <mat-icon>delete_sweep</mat-icon>
      <span>{{ 'TOOLBAR.REMOVE_LAYERS' | translate }}</span>
    </button> -->

    <!-- Delete scene -->
     <!--   <button mat-menu-item (click)="deleteTransformGroup(mapService.scene)" *ngIf="permissions?.can?.delete?.scene">
      <mat-icon>delete</mat-icon>
      <span>{{ 'TOOLBAR.DELETE_SCENE' | translate }}</span>
    </button>
  </mat-menu>

  <button class="fdm-linked pointer fdm-tools-button float-right" 
    [matTooltip]="'SCENE.OPTIONS' | translate" id="scene-options" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation();">
    <fa-icon icon="cog"></fa-icon>
  </button>

-->  

  <!-- <button [matMenuTriggerFor]="view_mode" style="width:45px;border-radius:8px;"
    class="fdm-linked pointer fdm-tools-button fdm-help float-right" 
    [matTooltip]="'NAV.VIEW_MODE' | translate">
    <fa-icon [icon]="uiManager.uiMode == 'normal' ? 'expand' : 'compress'"></fa-icon>
    <fa-icon style="margin-left:7px;opacity:0.5;font-size:10px;" icon="chevron-down"></fa-icon>
  </button>
  <mat-menu #view_mode="matMenu" [overlapTrigger]="false">
    <ng-container *ngFor="let mode of uiManager.uiModes">
      <button mat-menu-item (click)="uiManager.switchMode(mode.id);">
        <fa-icon class="ml-1 mr-1" [icon]="mode.icon"></fa-icon> {{ mode.labelToken | translate }}
      </button>
    </ng-container>    
  </mat-menu> -->

  <button [matMenuTriggerFor]="view_sections" style="width:45px;border-radius:8px;"
    class="fdm-linked pointer fdm-tools-button fdm-help float-right" 
    [matTooltip]="'NAV.VIEW_SECTIONS' | translate">
    <fa-icon icon="th-list"></fa-icon>
    <fa-icon style="margin-left:7px;opacity:0.5;font-size:10px;" icon="chevron-down"></fa-icon>
  </button>

  <!-- Menu drop-down for view modes -->
  <mat-menu #view_sections="matMenu" [overlapTrigger]="false">
    <ng-container *ngFor="let mode of uiManager.viewSection.items | keyvalue: originalOrder">
      <div style="margin:2px;padding:4px 6px;font-size:13px;color:#888;" (click)="uiManager.toggleSection(mode.key);$event.stopPropagation();">
        <input type="checkbox" class="fdm-checkbox" [(ngModel)]="mode.value.show" style="margin-right:4px;" /> 
        {{ mode.value.labelToken | translate }}
      </div>
    </ng-container>    
  </mat-menu>

  <!-- Quick guides icon -->
  <button *ngIf="permissions?.can?.show_intro_tour?.site_settings" 
    class="fdm-linked pointer fdm-tools-button fdm-help float-right" 
    [matTooltip]="'NAV.QUICK_GUIDES' | translate" (click)="uiManager.toggleQuickGuidePopup('map', true)">
    <fa-icon icon="question-circle"></fa-icon>
  </button>

</div>

<div class="fdm-sidebar-tabs-body no-docker" *ngIf="uiManager.uiMode == 'normal'">

  <input *ngIf="mapService.debugData" [(ngModel)]="mapService.debugData" style="width:100%;" />

  <ul class="fdm-sidebar-list-simple fdm-sidebar-list-tight"
  [class.fdm-drag-drop-zone-hover]="uploadDragHover" 
			(drop)="mainService.dropFile($event);dragDropControl($event,false)" 
			(dragover)="dragDropControl($event,true)" 
			(dragenter)="dragDropControl($event,true)" 
			(dragleave)="dragDropControl($event,false)"
  >

    <!-- <ng-container *ngFor="let scene of this.mapService.scenes; let i = index;"> -->
      <li [ngClass]="{'text-default':loading}" style="padding:0;margin:0;">


        <!-- <div class="text-center" *ngIf="mapService.scene && mapService.scene.id == item.id">
          <div class="fdm-sidebar-toolbar fdm-buttons clearfix">
      
            <mat-menu #menu="matMenu" [overlapTrigger]="false">
              <button mat-menu-item (click)="renameScene(item)" *ngIf="permissions?.can?.rename?.scene">
                <mat-icon>edit</mat-icon>
                <span>{{ 'TOOLBAR.EDIT_NAME' | translate }}</span>
              </button>
              <mat-divider></mat-divider>
              <ng-container *ngIf="mapService && mapService.currentProject">
                <button mat-menu-item (click)="setSceneAsDefault()" *ngIf="mapService.scene.id != mapService.currentProject['lastActiveScene']">
                  <fa-icon icon="check-square" style="font-size:26px;margin-right:16px;opacity:0.54;"></fa-icon>
                  <span>{{ 'TOOLBAR.SET_DEFAULT' | translate }}</span>
                </button>
                <button mat-menu-item disabled *ngIf="mapService.scene.id == mapService.currentProject['lastActiveScene']">
                  <fa-icon icon="check-square" style="font-size:26px;margin-right:16px;color:rgb(207, 233, 207)"></fa-icon>
                  <span>{{ 'TOOLBAR.IS_DEFAULT' | translate }}</span>
                </button>
              </ng-container>
              <button mat-menu-item (click)="editing = !editing" *ngIf="mapService.scene && mapService.scene.id == item.id && permissions?.can?.delete?.layer">
                <mat-icon>delete_sweep</mat-icon>
                <span>{{ 'TOOLBAR.REMOVE_LAYERS' | translate }}</span>
              </button>
              <button mat-menu-item (click)="deleteTransformGroup(item)" *ngIf="permissions?.can?.delete?.scene">
                <mat-icon>delete</mat-icon>
                <span>{{ 'TOOLBAR.DELETE_SCENE' | translate }}</span>
              </button>
            </mat-menu>
      
            <button class="fdm-linked pointer fdm-tools-button float-left" 
              (click)="clickAddData()"
              [matTooltip]="'PROJECT.DIALOG.ADD_LAYER' | translate">
              <fa-icon [icon]="['far','layer-plus']"></fa-icon>
            </button>
      
            <button class="fdm-linked pointer fdm-tools-button float-left" 
              [matTooltip]="'PROJECT.DIALOG.PLAYER' | translate" 
              [class.fdm-is-on]="mapComp?.isPlaying"
              (click)="changeOpacityAllTransform()">
              <fa-icon [icon]="['far','play']"></fa-icon>
            </button>
      
            <button class="fdm-linked pointer fdm-tools-button float-right" 
              [matTooltip]="'PROJECT.DIALOG.LAYER_OPTIONS' | translate" 
              [matMenuTriggerFor]="menu"
              (click)="$event.stopPropagation();">
              <fa-icon icon="cog"></fa-icon>
            </button>
      
            <button class="fdm-linked pointer fdm-tools-button fdm-help float-right" 
            [matTooltip]="'NAV.QUICK_GUIDES' | translate" (click)="clickQuickGuides()">
              <fa-icon icon="question-circle"></fa-icon>
            </button>
      
          </div>
        </div> -->

        <!-- if not the current one, just show name -->
        <!-- disabled; <div class="fdm-sidebar-scene-header fdm-buttons fdm-link" (click)="sceneController.loadScene(item.id)"
             *ngIf="(item && item.id) && mapService.scene && mapService.scene.id !== item.id && permissions?.can?.switch?.scene">

          <i class="fdm-icon fdm-icon-thin float-right"
            [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation();">
            <fa-icon icon="ellipsis-v" style="font-size:10px;color:#888;"></fa-icon>
          </i>

          <span>
            <fa-icon class="fdm-silent-icon" icon="caret-right"></fa-icon>
            {{ item.name }}
          </span>

        </div> -->


        <!-- if current scene, show the header, toolbar, and all layers -->
        <!-- <div class="fdm-buttons fdm-linked" *ngIf="mapService.scene && mapService.scene.id == item.id"> -->

          <!-- layer options menu -->
          <!-- <i class="fdm-icon fdm-icon-thin float-right" style="margin-left:10px;"
            *ngIf="mapService?.canWrite"
            [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation();"
            [matTooltip]="'PROJECT.DIALOG.LAYER_OPTIONS' | translate">
            <fa-icon icon="ellipsis-v"></fa-icon>
          </i> -->

          <!-- the player icon -->
          <!-- <i class="fdm-icon float-right"
            *ngIf="mapService.scene && mapService?.canWrite"
            [class.fdm-is-on]="mapComp?.isPlaying"
            (click)="changeOpacityAllTransform()"
            [matTooltip]="'PROJECT.DIALOG.PLAYER' | translate">
            <fa-icon [icon]="['far','play']"></fa-icon>
          </i> -->


          <!-- add new layer icon -->
          <!-- <i class="fdm-icon float-right"
            *ngIf="mapService.scene && mapService?.canWrite"
            (click)="clickAddData()"
            [matTooltip]="'PROJECT.DIALOG.ADD_LAYER' | translate">
            <fa-icon [icon]="['far','layer-plus']"></fa-icon>
          </i> -->

          <!-- <span class="float-right fdm-linked fdm-help-icon"><fa-icon [matTooltip]="'NAV.QUICK_GUIDES' | translate" (click)="clickQuickGuides()" icon="question-circle"></fa-icon></span> -->


          <!-- <span class="fdm-text-bold">
            <fa-icon class="fdm-silent-icon" icon="caret-down"></fa-icon>
            {{ item.name }}
          </span> -->

        <!-- </div> -->


        <div class="clearfix"></div>


        <!-- if current scene, show the layers -->
        <div class="fdm-sidebar-scene-body">

          <div *ngIf="mapComponent?.isPlaying">
            <player-comp></player-comp>
          </div> 

          <!-- spinner for loading -->
          <div class="mt-4 w-100 text-center" *ngIf="loading">
            <mat-spinner style="margin:0 auto;" strokeWidth="3"></mat-spinner>
          </div>

          
          <!-- moved to map.comp     <div class="scene-shortcuts" *ngIf="mapComponent.scenePlugins">
            <ng-container *ngFor="let shortcut of mapComponent.scenePlugins.listShortcuts(mapService.scene)">
              <fa-icon *ngIf="shortcut.show" [matTooltip]="shortcut['tooltip'] | translate" (click)="clickScenePluginShortcut(shortcut,item,$event)" [class.selected]="shortcut.active" [icon]="shortcut.icon"></fa-icon>
            </ng-container>
            <span class="float-right fdm-linked fdm-help-icon"><fa-icon [matTooltip]="'NAV.QUICK_GUIDES' | translate" (click)="clickQuickGuides()" icon="question-circle"></fa-icon></span>
          </div> -->

          <!-- <textarea style="width:100%;height:170px;font-size:10px;">{{ scenePlugins.activePlugins | json }}</textarea>
          <textarea style="width:100%;height:170px;font-size:10px;">{{ mapService.scene._plugins | json }}</textarea> -->

          <!-- show all other data / layers in this scene -->
          <ul cdkDropList (cdkDropListDropped)="drop($event)" class="fdm-sidebar-scene-layers" *ngIf="!loading">

            <!-- Environment -->
            <li *ngIf="mapService.currentProject && uiManager.viewSection.isShowing('environment')" class="fdm-sidebar-scene-layer header hasItems">
              <div class="fdm-layer-tools" *ngIf="!editing && localPluginControllerCache.environment">

                <ng-container *ngFor="let shortcut of localPluginControllerCache.environment.listShortcuts(mapService.currentProject)">
                  <fa-icon *ngIf="shortcut.show" [icon]="shortcut.icon" class="fdm-layer-icon" [class.fdm-icon-selected]="shortcut.active" 
                    [matTooltip]="shortcut['tooltip'] | translate"
                    (click)="localPluginControllerCache.environment.component.clickPluginShortcut(shortcut,mapService.currentProject,$event)">
                  </fa-icon>
                </ng-container>

              </div>

              <div class="fdm-layer-title fdm-layer-section-title">
                <fa-icon [fixedWidth]="true" class="fdm-silent-icon" icon="eclipse"></fa-icon>
                <span translate>NAV.SECTION_ENVIRONMENT</span>
              </div>

              <!-- because we're floating stuff, make sure we clear it all up -->
              <div class="clearfix"></div>
            </li>

            <ng-container *ngIf="uiManager.viewSection.isShowing('jobs')">

              <li class="fdm-sidebar-scene-layer header" style="margin-top:0 !important;" [ngClass]="{'hasItems':currentSceneJobs.length,'isOpen':showJobs}">
                <div class="fdm-layer-title fdm-link fdm-layer-section-title">
                  <!-- title -->
                  <span (click)="showJobs = ! showJobs">
                    <fa-icon *ngIf="!showJobs" class="fdm-silent-icon" [fixedWidth]="true" icon="caret-right" matTooltip=" {{'MAP.LAYERS.SEE_JOBS' | translate }}"></fa-icon>
                    <fa-icon *ngIf="showJobs" class="fdm-silent-icon" [fixedWidth]="true" icon="caret-down" matTooltip="{{'MAP.LAYERS.HIDE_JOBS' | translate }}"></fa-icon>
                    {{ 'GENERIC.JOBS' | translate }} <i>{{ currentSceneJobs.length }}</i>
                  </span>
                </div>
                <div class="clearfix"></div>
              </li>

              <li *ngIf="showJobs" [@slideInOut] class="fdm-sidebar-scene-layer">
              
                <div style="margin:0;padding:0;margin-bottom:10px;">

                  <div *ngIf="!currentSceneJobs.length" translate class="alert clearfix" style="color:orange;">MAP.LAYERS.NO_JOBS</div>

                  <table class="fdm-sidebar-table-list">
                    <tr *ngFor="let d of currentSceneJobs">
                      <td *ngIf="strCompareNocase (d.jobType.uid, 'photogrammetry')" class="fdm-linked" style="padding:4px;width:15px;text-align:right;" [routerLink]="['photogram']">
                        <fa-icon class="fdm-silent-icon" icon="cubes" ></fa-icon>
                      </td>
                      <td *ngIf="strCompareNocase (d.jobType.uid, 'photogrammetry')" class="fdm-linked" style="padding:4px;" [routerLink]="['photogram']">
                        {{ d.jobType.name }} <span style="color:#999;">{{ 'MAP.LAYERS.UPDATED' | translate }} {{ d.dateUpdated | dateAgo | async}}</span>
                      </td>

                      <td *ngIf="!strCompareNocase (d.jobType.uid, 'photogrammetry')" style="padding:4px;width:15px;text-align:right;">
                        <fa-icon class="fdm-silent-icon" icon="question" ></fa-icon>
                      </td>
                      <td *ngIf="!strCompareNocase (d.jobType.uid, 'photogrammetry')" style="padding:4px;">
                        {{ d.jobType.name }} [{{ d.jobType.uid }}] <span style="color:#999;">{{ 'MAP.LAYERS.UPDATED' | translate }} {{ d.dateUpdated | dateAgo | async }}</span>
                      </td>

                    </tr>
                  </table>

                </div>

              </li>

            </ng-container>

            <ng-container *ngIf="uiManager.viewSection.isShowing('files')">

              <li class="fdm-sidebar-scene-layer header" *ngIf="permissions?.can?.see?.files" [ngClass]="{'hasItems':allAdditionalFiles.length,'isOpen':showSceneFiles}">

                <div class="fdm-layer-title fdm-link fdm-layer-section-title">

                  <!-- title -->
                  <span (click)="showSceneFiles = ! showSceneFiles" id="additional-files">
                    <fa-icon *ngIf="!showSceneFiles" class="fdm-silent-icon" [fixedWidth]="true" icon="caret-right" matTooltip=" {{'MAP.LAYERS.SEE_FILES' | translate }}"></fa-icon>
                    
                    
                    <!-- additional files-->
                    <fa-icon *ngIf="showSceneFiles" class="fdm-silent-icon"  [fixedWidth]="true" icon="caret-down" matTooltip=" {{'MAP.LAYERS.HIDE_FILES' | translate }}"></fa-icon>
                    {{ 'MAP.LAYERS.ADDITIONAL_FILES' | translate }}

                    <!-- <span *ngIf="sceneFiles">({{ sceneFiles.length }})</span> -->
                    <i *ngIf="!sceneFilesChecked && !virtualSceneFilesChecked">{{ allAdditionalFiles.length }}</i>
                    <i *ngIf="sceneFilesChecked && !virtualSceneFilesChecked">{{ allAdditionalFiles.length }}</i>
                    <i *ngIf="!sceneFilesChecked && virtualSceneFilesChecked">{{ allAdditionalFiles.length }}</i>
                    <i *ngIf="sceneFilesChecked && virtualSceneFilesChecked">{{ allAdditionalFiles.length }}</i>
                  </span>

                </div>
                <div class="clearfix"></div>
              </li>

              <li class="fdm-sidebar-scene-layer" *ngIf="permissions?.can?.see?.files && showSceneFiles" [@slideInOut]>
              
                <div style="margin:0;padding:0;margin-bottom:10px;">

                  <div *ngIf="allAdditionalFiles.length < 1" translate class="alert clearfix" style="color:orange;">MAP.LAYERS.NO_FILES</div>

                  <table *ngIf="allAdditionalFiles" class="fdm-file-list">
                    <ng-container  *ngFor="let d of allAdditionalFiles">
                      <tr>

                        <td style="text-align:center;max-width:15px;">
                          <fa-icon class="fdm-linked" [icon]="'ICON.' + (d?.dataType?.uid || 'UNKNOWN') | translate"></fa-icon>
                          <fa-icon class="fdm-linked" [icon]="'ICON.UNKNOWN' | translate"></fa-icon>
                        </td>
                        <td style="text-align:left;overflow-x:hidden;text-overflow:ellipsis;max-width:150px;min-width:50px;">
                          {{ d.name }} 
                          <div style="color:orange" *ngIf="d['lastProgress'] && d['lastProgress']['status'] && d['lastProgress']['status'] == 'error'">
                            <span [title]="d['lastProgress']['uid'] + ' - ' + ( d['lastProgress']['dataset'] ? (d['lastProgress']['dataset']['name']+':'+d['lastProgress']['dataset']['id']) : 'no dataset')">
                              <fa-icon icon="exclamation-triangle"></fa-icon> {{ d['lastProgress']['info'] }}
                            </span>
                        </div>
                        </td>
                        <td>
                          <span style="color:#999;">{{ humanFileSize(d.size) }}</span>
                        </td>
                        <td>
                          <span translate style="color:#999;">{{ d.dateUpdated | dateAgo | async }}</span>
                        </td>

                        <td>
                        
                          <ng-container *ngIf="permissions?.can?.download?.files && hasAdHocJobs(d) > 0">
                            <fa-icon [matMenuTriggerFor]="proc_select" class="fdm-linked fdm-icon-large" icon="cog"></fa-icon>
                            <mat-menu #proc_select="matMenu" [overlapTrigger]="false">
                              <ng-container *ngIf="d.dataType">
                                <button *ngFor="let pr of d.dataType._adhocTransforms" mat-menu-item (click)="incomingData.process(d,pr,service,dialog)"> {{ pr?.name }}</button>
                              </ng-container>
                            </mat-menu>
                          </ng-container> 

                          <!-- <td style="text-align:right;font-size:10px;" *ngIf="permissions?.can?.download?.files && d.dataType?._adhocTransforms.length && d.transforms?.length && d.transforms[0] == null" >
                            <fa-icon (click)="adHoc(d,d.dataType?._adhocTransforms[0])" class="fdm-link fdm-icon-large" icon="cog" [matTooltip]="'WORKFLOWS.ACTION_TYPE.PROCESS' | translate"></fa-icon> 
                          </td> -->

                          <!-- Download file -->
                          <ng-container *ngIf="permissions?.can?.download?.files">
                            <fa-icon *ngIf="d['isVirtual']" (click)="removeLinkedFile(d)" class="fdm-link fdm-icon-large fdm-annotation-color-red" icon="times"></fa-icon>
                            <a vlink="data" [model]="d">
                              <fa-icon class="fdm-link fdm-icon-large" icon="download"></fa-icon>
                            </a>
                          </ng-container> 

                          <!-- Delete additional file -->
                          <ng-container *ngIf="permissions?.can?.delete?.files">
                            <fa-icon (click)="deleteFromFile(d)" icon="trash" [matTooltip]="'GENERIC.DELETE' | translate" class="fdm-link fdm-icon-large fdm-annotation-color-red"></fa-icon>
                          </ng-container> 

                        </td>

                      </tr>
                    </ng-container>
                    
                  </table>

                </div>

              </li>

            </ng-container>
            <!-- <li *ngIf="mapService?.viewer?.dataSourceDisplay?.defaultDataSource?._visualizers">
              <div *ngFor="let v of mapService.viewer.dataSourceDisplay.defaultDataSource._visualizers" style="border:solid 1px #ddd;padding:3px;margin:3px 0;">
                <b>{{ _visualizer_label(v) }}</b>
                <div *ngFor="let i of _visualizer(v)" style="padding-left:10px;">
                  {{ i }}
                </div>
              </div>
            </li> -->

            <ng-container *ngIf="uiManager.viewSection.isShowing('bookmarks')">
              <fdm-buckets *ngIf="sceneBuckets" [controller]="sceneBuckets"></fdm-buckets>
            </ng-container>

            <!-- Photo bucket -->
            <ng-container *ngIf="uiManager.viewSection.isShowing('photos')">
              <li class="fdm-sidebar-scene-layer header" [ngClass]="{'hasItems':mapService.scene?._photo_count}">

                <div class="fdm-layer-tools" *ngIf="!editing">

                  <!-- Photo tools -->

                  <ng-container *ngIf="mapService.scene?._photo_count > 0">
                    <fa-icon *ngIf="permissions?.can?.see?.photogrammetry"
                      [matTooltip]="'MAP.photogram' | translate"
                      [routerLink]="['photogram']" (click)="mapComponent.detailsNav.open()" class="fdm-layer-icon"
                      icon="cubes"></fa-icon>
                    <fa-icon *ngIf="!permissions?.can?.see?.photogrammetry"
                        [matTooltip]="'MAP.photogram' | translate"
                        class="fdm-layer-icon" style="color:#ccc!important"
                        icon="cubes"></fa-icon>
                  </ng-container>

                  <!-- External photo bucket -->
                  <mat-slide-toggle id="guide-open-photo-bucket" (click)="clickPhotoBucket();" *ngIf="mapComponent && mapComponent?.photosNav" 
                    class="float-right mat-slide-toggle-atomic" color="primary" matTooltip="{{ 'MAP.VIEW_PHOTOS' | translate }}" [checked]="mapComponent.photosNav.opened">
                  </mat-slide-toggle>
                </div>

                <div class="fdm-layer-title fdm-layer-section-title">
                  <fa-icon [fixedWidth]="true" class="fdm-silent-icon" icon="images"></fa-icon>
                  <span>{{ 'MAP.PHOTO_COUNT' | translate }} <i>{{ mapService.scene?._photo_count }}</i></span>
                </div>

                <!-- because we're floating stuff, make sure we clear it all up -->
                <div class="clearfix"></div>
              </li>

              <li *ngIf="false" class="fdm-sidebar-scene-layer">

                <!-- Delete photos -->

                <fa-icon icon="trash" class="fdm-layer-icon danger float-right"
                        *ngIf="editing && mapService.scene?._photo_count > 0" (click)="nukePhotos()"></fa-icon>

                <div class="fdm-layer-tools" *ngIf="!editing">

                  <!-- Photo tools -->

                  <ng-container *ngIf="mapService.scene?._photo_count > 0">
                    <fa-icon *ngIf="permissions?.can?.see?.photogrammetry"
                      [matTooltip]="'MAP.photogram' | translate"
                      [routerLink]="['photogram']" (click)="mapComponent.detailsNav.open()" class="fdm-layer-icon"
                      icon="cubes"></fa-icon>
                    <fa-icon *ngIf="!permissions?.can?.see?.photogrammetry"
                        [matTooltip]="'MAP.photogram' | translate"
                        class="fdm-layer-icon" style="color:#ccc!important"
                        icon="cubes"></fa-icon>
                  </ng-container>

                  <!-- External photo bucket -->
                  <!-- <span> {{ mapComp }} </span> -->
                  <mat-slide-toggle id="guide-open-photo-bucket" (click)="clickPhotoBucket();" *ngIf="mapComponent && mapComponent?.photosNav" 
                    class="float-right mat-slide-toggle-atomic" color="primary" matTooltip="{{ 'MAP.VIEW_PHOTOS' | translate }}" [checked]="mapComponent.photosNav.opened">
                  </mat-slide-toggle>

                  <!-- <fa-icon *ngIf="mapComp?.viewPhotoBucket && !mapComp?.photosNav?.opened" matTooltip="Open photo bucket" (click)="mapComp?.togglePhotoBucket()"
                        icon="folder-open" class="fdm-layer-icon"></fa-icon> -->
                </div>

                <div class="fdm-layer-title">

                  <!-- View the photos -->

                  <span class="fdm-checkboxes">
                    <input [id]=" 'l' + mapService.scene.id"
                          type="checkbox" class="fdm-checkbox"
                          [(ngModel)]="mapService.showPhotos[mapService.scene.id]" (change)="showHidePhotos($event)"/>
                    <label [for]=" 'l' + mapService.scene.id"></label>
                  </span>

                  <!-- Photos -->
                  <span [class.fdm-layer-title-disabled]="!mapService.showPhotos[mapService.scene.id]"
                        [class.fdm-linked]="mapService.showPhotos[mapService.scene.id]"
                        (click)="flyToPhotos()"
                  >
                    <fa-icon class="fdm-silent-icon" icon="camera" ></fa-icon>
                    {{ 'MAP.PHOTO_COUNT' | translate }} <i>{{ mapService.scene?._photo_count }}</i>
                  </span>
                </div>

                <!-- Because we're floating stuff, make sure we clear it all up -->

                <div class="clearfix"></div>

              </li>
            </ng-container>

            

            

            <!-- <li>
              <textarea style="width:100%;height:200px;font-size:9px;">{{ sceneTransformsByType | json }}</textarea>
              <textarea style="width:100%;height:200px;font-size:9px;">{{ sceneTransformsByCategory | json }}</textarea>
            </li> -->


            <!-- legends and lore -->

            <div [@slideInOut] *ngIf="uiManager.viewSection.isShowing('legends')" [ngClass]="{'isOpen':showLegends}">

              <li class="fdm-sidebar-scene-layer header">
                <div class="fdm-layer-tools" *ngIf="!editing">

                </div>
  
                <div class="fdm-layer-title fdm-layer-section-title">
                  
                  <span (click)="showLegends = ! showLegends">
                    <fa-icon *ngIf="!showLegends" class="fdm-silent-icon" [fixedWidth]="true" icon="caret-right" matTooltip=" {{'MAP.LAYERS.SEE_FILES' | translate }}"></fa-icon>
                    <fa-icon *ngIf="showLegends" class="fdm-silent-icon"  [fixedWidth]="true" icon="caret-down" matTooltip=" {{'MAP.LAYERS.HIDE_FILES' | translate }}"></fa-icon>
                  {{ 'NAV.SECTION_LEGENDS' | translate }}
                </span>
                  <!-- [{{ mapComponent ? true : false }}] [{{ mapComponent && mapComponent['basemapPlugins'] ? true : false }}] -->
                </div>
  
                <!-- because we're floating stuff, make sure we clear it all up -->
                <div class="clearfix"></div>
              </li>

              <div style="margin-bottom:20px;" *ngIf="showLegends">
                <ng-container *ngFor="let item of sceneTransforms">

                  <ng-container *ngIf="mapService.scene['layerProps']['toggle_' + item.id]">
                  
                    <li class="fdm-sidebar-scene-layer listable" style="font-size:15px;padding:3px 5px;" [class.fdm-hover-main]="measureHelper?.pickedModel?.primitive?.transform_id == item.id">
            
                      <!-- Layer options -->
                        <div class="fdm-layer-tools" style="color:#999;font-size:12px;width:50px;">
            
                          
                          <!-- <span class="fdm-show-options">
                            <fa-icon *ngIf="!item.showOptions && mapService.scene['layerProps']['toggle_' + item.id]" class="fdm-layer-icon-gray" icon="chevron-down" matTooltip=" {{'GENERIC.OPTIONS' | translate }}" (click)="item.showOptions = true"></fa-icon>
                            <fa-icon *ngIf="item.showOptions" class="fdm-layer-icon-gray" icon="chevron-up" matTooltip="{{'GENERIC.OPTIONS' | translate }}" (click)="item.showOptions = false"></fa-icon>
                          </span> -->
                        </div>
            
                        <div  class="fdm-layer-title" style="width:240px;">
            
                          <span class="fdm-checkboxes" *ngIf="mapService.scene['layerProps']['toggle_' + item.id]">
                            <input [id]=" 'vt' + item.id" class="fdm-checkbox fdm-linked" type="checkbox"
                              [checked]="sceneTransformsActiveViews[item.id]"
                              (click)="toggleView(item)" />
                            <label [for]=" 'vt' + item.id"></label>
                          </span>
                          
                          <span class="fdm-checkboxes" *ngIf="!mapService.scene['layerProps']['toggle_' + item.id]">
                            <label [for]=" 'vt' + item.id"></label>
                            <fa-icon class="fdm-silent-icon" style="display:inline-block;width:16px;"></fa-icon>
                          </span>
                      
                          <span [matTooltip]="item.name || item.ds_name" [class.fdm-layer-title-disabled]="!mapService.scene['layerProps']['toggle_' + item.id]"
                                [class.fdm-linked]="mapService.scene['layerProps']['toggle_' + item.id]" (click)="flyTo(item)">
                              <fa-icon class="fdm-silent-icon" [fixedWidth]="true" [icon]="'ICON.' + (item.ds_type_uid || 'UNKNOWN') | translate"></fa-icon>
                              {{ item.name || item.ds_name }} 
                          </span>
                      
                        </div>

                        <!-- <span *ngIf="item.urlMeta">inTransform</span> -->
                        <span *ngIf="item.input.urlMeta">inDataset</span>
                        <span *ngIf="item.proxyMeta && item.proxyMeta.legends && item.proxyMeta.legends.length">inTransform</span>
            
                        <div class="clearfix"></div>
            
                    </li>
            
                  </ng-container>
            
                </ng-container>
              </div>
            </div>
            

            <!-- REFACTORED Uploads and processing items -->
            <div [@slideInOut] *ngIf="uiManager.viewSection.isShowing('incoming') && incomingData.length" style="margin-bottom:20px;">
              
                <li class="fdm-sidebar-scene-layer header isOpen" [ngClass]="{'hasItems':incomingData.length}">
                  <div class="fdm-layer-title fdm-layer-section-title">
                    <fa-icon [fixedWidth]="true" class="fdm-silent-icon" icon="coffee"></fa-icon>
                    <span>{{ 'MAP.LAYERS.INCOMING' | translate }} <i>{{ incomingData.length }}</i></span>
                  </div>

                  <!-- because we're floating stuff, make sure we clear it all up -->
                  <div class="clearfix"></div>
                </li>

                <ng-container *ngIf="incomingData.lengthPhotos">

                  <li class="fdm-sidebar-scene-layer fdm-layer-processing fdm-buttons">
                    <fa-icon class="fdm-silent-icon" icon="camera" ></fa-icon>
                    {{ 'MAP.PHOTO_COUNT' | translate }} <i style="background-color:rgb(235, 235, 235);padding:1px 2px;border-radius:2px;">{{ incomingData.lengthPhotosBatched }}</i> 
                    <mat-progress-bar style="margin:1px 5px 5px 5px;" [value]="incomingData.percentDone" [bufferValue]="incomingData.percentDone + incomingData.percentWorking" mode="buffer" color="primary">total</mat-progress-bar>
                  </li>

                  <!-- <li class="fdm-sidebar-scene-layer fdm-layer-processing fdm-buttons" style="padding-left:25px;border-left:none;">
                    <fa-icon class="fdm-silent-icon" icon="file-upload"></fa-icon>
                    {{ 'MAP.PHOTO_COUNT_UPLOADING' | translate }} <i>{{ incomingData.lengthPhotosUploading }}</i>
                    <mat-progress-bar style="margin:1px 5px 5px 5px;" [value]="(100 / incomingData.lengthPhotos) * incomingData.lengthPhotosUploading" mode="determinate" color="warn">uploading</mat-progress-bar>
                  </li>
  
                  <li class="fdm-sidebar-scene-layer fdm-layer-processing fdm-buttons" style="padding-left:25px;border-left:none;">
                    <fa-icon class="fdm-silent-icon" icon="tachometer-alt"></fa-icon>
                    {{ 'MAP.PHOTO_COUNT_PROCESSING' | translate }} <i>{{ incomingData.lengthPhotosProcessing }}</i>
                    <mat-progress-bar style="margin:1px 5px 5px 5px;" [value]="(100 / incomingData.lengthPhotos) * incomingData.lengthPhotosProcessing" mode="determinate" color="warn">processing</mat-progress-bar>
                  </li> -->
                </ng-container>
              
                <ng-container *ngFor="let d of incomingData.items">

                  <!-- show only for current scene -->
                  <li class="fdm-sidebar-scene-layer fdm-layer-processing fdm-buttons" *ngIf="!d['__name_based_photo']">

                    <!-- [{{incomingData.state[d.id]}}/{{hasAdHocJobs(d)}}] -->
                    <span class="fdm-button fdm-selected float-right" *ngIf="fourD.uploadsRunningMap[d.id]" (click)="incomingData.cancel(d)">
                      <fa-icon icon="times-circle"></fa-icon> {{ 'GENERIC.CANCEL' | translate }}
                    </span>

                    
                    <ng-container *ngIf="incomingData.state[d.id] !== 'upload-ready' && hasAdHocJobs(d) == 0">
                      <span class="ml-1 fdm-count-neat">
                        <fa-icon icon="times" class="fdm-layer-icon" (click)="incomingData.remove(d)"></fa-icon>
                      </span>
                    </ng-container>

                    <ng-container *ngIf="!fourD.uploadsRunningMap[d.id] && mapComponent?.generatingTransforms.indexOf(d.id) === -1">

                      <ng-container *ngIf="incomingData.state[d.id] == 'upload-ready' && hasAdHocJobs(d) > 0">
                        <fa-icon icon="trash" class="fdm-layer-icon danger float-right" (click)="incomingData.remove(d)"></fa-icon>
                      </ng-container>
                      
                      <ng-container *ngIf="incomingData.state[d.id] == 'upload-ready' && hasAdHocJobs(d) > 0">
                        <button class="ml-2 float-right" mat-flat-button color="primary" [matMenuTriggerFor]="proc_select"> {{'FILE_LIST.TILING_WIZARD.PROCESS' | translate }} <fa-icon icon="chevron-down"></fa-icon></button> 
                        <mat-menu #proc_select="matMenu" [overlapTrigger]="false">
                          <ng-container *ngIf="d.dataType">
                            <button *ngFor="let pr of d.dataType._adhocTransforms" mat-menu-item (click)="incomingData.process(d,pr,service,dialog)"> {{ pr?.name }}</button>
                          </ng-container>
                        </mat-menu>
                      </ng-container>

                    </ng-container>

                    <span>

                        <fa-icon class="fdm-silent-icon" [fixedWidth]="true" [icon]="'ICON.' + (d?.dataType?.uid || 'UNKNOWN') | translate"></fa-icon>

                      {{ d.name }}

                      <span class="ml-1 fdm-count-neat" *ngIf="fourD.uploadsRunningMap[d.id]">{{'GENERIC.UPLOADING' | translate }} {{ fourD.uploadsRunningMap[d.id].progress | percent }}%</span>

                      <ng-container *ngIf="incomingData.state[d.id] == 'upload-ready' && hasAdHocJobs(d) == 0">
                        <span class="ml-1 fdm-count-neat" *ngIf="!d.incomplete" (click)="incomingData.remove(d)">
                          {{'FILE_LIST.TILING_WIZARD.IN_FILES' | translate }}
                          <fa-icon icon="times" class="fdm-layer-icon"></fa-icon>
                        </span>
                      </ng-container>

                      <ng-container *ngIf="!fourD.uploadsRunningMap[d.id]">
                        <span class="ml-1 fdm-count-neat" *ngIf="!d.incomplete">
                          {{'FILE_LIST.TILING_WIZARD.UPLOADED' | translate }}
                        </span>
                        <!-- <span class="ml-1 fdm-count-neat" *ngIf="incomingData.state[d.id] == 'upload-finished'">
                        {{'FILE_LIST.TILING_WIZARD.UNPROCESSED' | translate }}
                        </span> -->
                      </ng-container>

                      <span class="ml-1 fdm-count-neat" *ngIf="incomingData.state[d.id] == 'process-working'">
                        {{'FILE_LIST.TILING_WIZARD.PROCESSING' | translate }}
                      </span>

                    </span>

                    <div class="clearfix"></div>

                    <mat-progress-bar *ngIf="fourD.uploadsRunningMap[d.id]" style="margin:1px 5px 5px 5px;" [value]="fourD.uploadsRunningMap[d.id].progress * 100" [mode]="fourD.uploadsRunningMap[d.id].progress?'determinate':'indeterminate'" color="warn"></mat-progress-bar>
                    <mat-progress-bar *ngIf="!fourD.uploadsRunningMap[d.id] && ( incomingData.state[d.id] == 'process-working' )" style="margin:1px 5px 5px 5px;" mode="indeterminate" color="accent"></mat-progress-bar>

                  </li>

                </ng-container>

                <!--
                <div *ngIf="incomingData.state">state <textarea style="width:100%;height:200px;font-size:9px;">{{ incomingData.state | json }}</textarea></div>
                <div *ngIf="incomingData.state">log <textarea style="width:100%;height:200px;font-size:9px;">{{ incomingData._log | json }}</textarea></div>
                -->
            </div>


            <!-- old Uploads and processing items -->
            <!-- <div [@slideInOut] *ngIf="false || uiManager.viewSection.isShowing('incoming') && mapService.datasetForLayers && mapService.datasetForLayers.length" style="margin-bottom:20px;">

              <li class="fdm-sidebar-scene-layer header isOpen" [ngClass]="{'hasItems':mapService.datasetForLayers.length}">
                <div class="fdm-layer-title fdm-layer-section-title">
                  <fa-icon [fixedWidth]="true" class="fdm-silent-icon" icon="coffee"></fa-icon>
                  <span>{{ 'MAP.LAYERS.INCOMING' | translate }} <i>{{ mapService.datasetForLayers.length }}</i></span>
                </div>

                <div class="clearfix"></div>
              </li>
            
              <ng-container *ngFor="let d of mapService.datasetForLayers">


                <li class="fdm-sidebar-scene-layer fdm-layer-processing" *ngIf="true || d['for_transform_group'] == mapService.scene.id">


                  <div class="fdm-buttons">

                    <fa-icon icon="trash" class="fdm-layer-icon danger float-right"
                          *ngIf="!fourD.uploadsRunningMap[d.id] && mapComponent?.generatingTransforms.indexOf(d.id) === -1"
                          (click)="deteteFromDatasetForLayers(d)"></fa-icon>

                    <span class="fdm-button fdm-selected float-right" *ngIf="fourD.uploadsRunningMap[d.id]" (click)="cancelUploading(d)">
                      <fa-icon icon="times-circle"></fa-icon> {{ 'GENERIC.CANCEL' | translate }}
                    </span>

                    <ng-container *ngIf="!fourD.uploadsRunningMap[d.id] && mapComponent?.generatingTransforms.indexOf(d.id) === -1">

                      <ng-container *ngIf="hasAdHocJobs(d) > 0">
                        <button class="ml-2 float-right" mat-flat-button color="accent" [matMenuTriggerFor]="proc_select"> {{'FILE_LIST.TILING_WIZARD.START_TILING' | translate }} <fa-icon icon="chevron-down"></fa-icon></button> 
                        <mat-menu #proc_select="matMenu" [overlapTrigger]="false">
                          <button *ngFor="let pr of d.dataType._adhocTransforms" mat-menu-item (click)="startAdHocJob(d,pr.id)"> {{ pr.name }}</button>
                        </mat-menu>
                      </ng-container>

                    </ng-container>

                    <span>
                        <fa-icon class="fdm-silent-icon" [fixedWidth]="true" icon="question"></fa-icon>

                      {{ d.name }} 


                      <span class="ml-1 fdm-count" *ngIf="fourD.uploadsRunningMap[d.id]">{{'GENERIC.UPLOADING' | translate }} {{ fourD.uploadsRunningMap[d.id].progress | percent }}%</span>
                      <ng-container *ngIf="!fourD.uploadsRunningMap[d.id]">
                        <span class="ml-1 fdm-count" *ngIf="mapComponent?.generatingTransforms.indexOf(d.id) !== -1">{{'FILE_LIST.TILING_WIZARD.PROCESSING' | translate }}</span>
                        <span class="ml-1 fdm-count" *ngIf="mapComponent?.generatingTransforms.indexOf(d.id) === -1">
                        {{'FILE_LIST.TILING_WIZARD.UNPROCESSED' | translate }}
                        </span>
                      </ng-container>
                      
                    </span>

                    <div class="clearfix"></div>

                  </div>

                  

                  <div *ngIf="!editing">

                    <ng-container *ngIf="fourD.uploadsRunningMap[d.id]">
                      <mat-progress-bar style="margin:10px 5px 5px 5px;"
                        [value]="fourD.uploadsRunningMap[d.id].progress * 100"
                        [mode]="fourD.uploadsRunningMap[d.id].progress?'determinate':'indeterminate'"
                        color="warn"></mat-progress-bar>
                    </ng-container>
                    
                    <mat-progress-bar style="margin:10px 5px 5px 5px;"
                      *ngIf="!fourD.uploadsRunningMap[d.id] && mapComponent?.generatingTransforms.indexOf(d.id) !== -1"
                      mode="indeterminate"
                      color="accent"></mat-progress-bar>


                    <p *ngIf="!fourD.uploadsRunningMap[d.id] && d.incomplete && mapComponent?.generatingTransforms.indexOf(d.id) === -1"> {{'TYPES.INCOMPLETE' | translate }} {{ d.incomplete_offset / d.size | percent }}% </p>

                  </div>

                </li>

              </ng-container>

              <div *ngIf="mapComponent?.generatingTransforms">processing <textarea style="width:100%;height:200px;font-size:9px;">{{ mapComponent.generatingTransforms | json }}</textarea></div>
              
            </div> -->


            <!-- Basemap -->
            <!-- [{{ mapService?.currentProject?.baseModel }}][{{ mapService?.scene?.baseModel }}] -->
            <li *ngIf="mapService.scene && uiManager.viewSection.isShowing('basemap')" class="fdm-sidebar-scene-layer header" [class.hasItems]="mapService.scene['baseModel']">
              <div class="fdm-layer-tools" *ngIf="!editing && localPluginControllerCache.basemap">

                <mat-slide-toggle (change)="toggleBasemap($event)" class="float-right mat-slide-toggle-atomic" color="primary" [(checked)]="mapService.scene['baseModel']"></mat-slide-toggle>

                <div *ngIf="!mapService.scene['baseModel']" class="fdm-circle-choice fdm-circle-choice-small fdm-annotation-color-white fdm-annotation-background-color-orange" 
                            [(colorPicker)]="mapService.scene['baseModelColor']" 
                            (colorPickerChange)="mapService.changeBaseModelColor()" 
                            [style.background]="mapService.scene['baseModelColor'] ? mapService.scene['baseModelColor'] : '#000'" 
                            cpOutputFormat="rgb"
                            cpAlphaChannel="disabled" 
                            matTooltip="{{ 'MAP.LAYERS.ADD_COLOR' | translate }}">
                              <fa-icon icon="chevron-down"></fa-icon>
                            </div>

                <ng-container *ngIf="mapService.scene['baseModel']">
                  <ng-container *ngFor="let shortcut of localPluginControllerCache.basemap.listShortcuts(mapService.scene)">
                    <fa-icon *ngIf="shortcut.show" icon="cog" class="fdm-layer-icon" [class.fdm-icon-selected]="shortcut.active" 
                      [matTooltip]="shortcut['tooltip'] | translate"
                      (click)="localPluginControllerCache.basemap.component.clickPluginShortcut(shortcut,mapService.scene,$event)">
                    </fa-icon>
                  </ng-container>
                </ng-container>

              </div>

              <div class="fdm-layer-title fdm-layer-section-title">
                <fa-icon [fixedWidth]="true" class="fdm-silent-icon" icon="map"></fa-icon>
                <span>{{ 'PLUGINS.BASEMAP_CONTROLLER.LABEL' | translate }}</span>
                <!-- [{{ mapComponent ? true : false }}] [{{ mapComponent && mapComponent['basemapPlugins'] ? true : false }}] -->
              </div>

              <!-- because we're floating stuff, make sure we clear it all up -->
              <div class="clearfix"></div>
            </li>

            <!-- Terrain Models -->
            <ng-container *ngIf="uiManager.viewSection.isShowing('terrain')">

              <!-- <ng-container *ngIf="sceneTerrainModels.length &lt; 2"> -->
                <li class="fdm-sidebar-scene-layer header" [ngClass]="{'hasItems':sceneTerrainModels.length, 'isOpen':sceneTerrainModels.length}">

                  <div class="fdm-layer-title fdm-layer-section-title">
                    <fa-icon [fixedWidth]="true" class="fdm-silent-icon" icon="globe"></fa-icon>
                    <span>{{ 'MAP.TERRAIN.MODELS' | translate }} <i>{{ sceneTerrainModels.length }}</i></span>
                  </div>

                  <!-- because we're floating stuff, make sure we clear it all up -->
                  <div class="clearfix"></div>
                </li>
              <!-- </ng-container> -->

              <ng-container *ngIf="sceneTerrainModels.length &gt; 1">
                <li class="fdm-sidebar-scene-layer listable">
                  <div class="fdm-layer-title">
                    <span class="fdm-checkboxes">
                      <input type="radio" class="fdm-radio fdm-linked" name="sceneTerrains" [checked]="!sceneSelectedTerrainModel" (click)="unselectTerrainModels()" />
                      {{ 'MAP.TERRAIN.DONT_SHOW' | translate }}
                    </span>
                  </div>

                  <!-- because we're floating stuff, make sure we clear it all up -->
                  <div class="clearfix"></div>
                </li>
              </ng-container>

            </ng-container>
          
            <!-- Each individual layer / data object -->
            <ng-container *ngFor="let item of mapService.sceneTransforms; let i = index;">

              <ng-container *ngIf="uiManager.viewSection.isShowing('layers')">

                <li *ngIf="item == sceneFirstTransformNotTerrainModel && sceneTerrainModels.length > 0" style="margin-top:20px;"></li>
                <li *ngIf="item == sceneFirstTransformNotTerrainModel" class="fdm-sidebar-scene-layer header isOpen" [ngClass]="{'hasItems':mapService.sceneTransforms.length - sceneTerrainModels.length > 0}">

                  <!-- TODO : (note to self later) TURN THIS OFF IF IT'S A SHARED LINK; FIND THE RIGHT ACCESS / ACL WIDGET TO DO IT THROUGH -->

                  <!-- Switch layers on/off-->
                  <div class="fdm-layer-tools" *ngIf="!editing && permissions?.can?.toggle?.layer" style="color:#999;font-size:12px;padding-right:5px;">
                    <fa-icon icon="minus-square" class="fdm-link fdm-icon-option" matTooltip="{{ 'MAP.LAYERS.TURN_OFF' | translate }}" id='switch-layer' (click)="toggleAll('layers',false)"></fa-icon>
                    <fa-icon icon="check-square" class="fdm-link fdm-icon-option" matTooltip="{{ 'MAP.LAYERS.TURN_ON' | translate }}" (click)="toggleAll('layers',true)"></fa-icon>
                  </div>

                  <div class="fdm-layer-title fdm-layer-section-title" id="layer-files">
                    <fa-icon [fixedWidth]="true" class="fdm-silent-icon" icon="layer-group"></fa-icon>
                    <span>{{ 'MAP.LAYERS.LABEL' | translate }} <i>{{ mapService.sceneTransforms.length - sceneTerrainModels.length }}</i> &nbsp;</span>
                  </div>
                  
                  <!-- because we're floating stuff, make sure we clear it all up -->
                  <div class="clearfix"></div>
                </li>
              </ng-container>

              <ng-container *ngIf="( item['isTerrain'] && uiManager.viewSection.isShowing('terrain') ) || ( !item['isTerrain'] && uiManager.viewSection.isShowing('layers') )">

                
                <li class="fdm-sidebar-scene-layer listable" cdkDragLockAxis="y" cdkDrag [cdkDragDisabled]="item['isTerrain']" 
                  [class.noshow]="!permissions?.can?.toggle?.layer && !mapService.scene['layerProps']['toggle_' + item.id]"
                > <!-- [class.fdm-hover-main]="measureHelper?.pickedModel?.primitive?.transform_id == item.id" -->

                  <div *ngIf="splitViewer && splitViewer.isSplitting && !item['canSplit']" class="fdm-hide-layer"></div>

                  <!-- invisible delete icon -->
                  <fa-icon icon="trash" class="fdm-layer-icon danger float-right" *ngIf="editing" (click)="deleteFromScene(item)"></fa-icon>

                  <!-- right-most items -->
                  <div class="fdm-layer-tools" *ngIf="!editing">

                    <!-- <ng-container *ngIf="item['fdm_features'] && !mapService.isValidForChangingOpacity(item) && item['fdm_features']['canAlpha']">
                      <fa-icon class="fdm-layer-icon fdm-layer-icon-issue" icon="exclamation-circle" matTooltip="{{ 'MAP.LAYERS.NO_OPACITY' | translate }}"></fa-icon>
                    </ng-container>
                    
                    <ng-container *ngIf="item?.issues?.heightOffset">
                      <fa-icon class="fdm-layer-icon fdm-layer-icon-issue" icon="exclamation-circle" *ngIf="item.issues.heightOffset.isOver && !item.issues.heightOffset.isDismissed" (click)="item.issues.heightOffset.isShown = !item.issues.heightOffset.isShown"></fa-icon>
                    </ng-container> -->

                    <!-- Eye icon / layer visibility -->
                    <ng-container *ngIf="splitViewer && !splitViewer.isSplitting">

                      <span *ngIf=" mapService.scene['layerProps']['toggle_' + item.id] && sceneController.callbacks[item.id] && sceneController.callbacks[item.id] != 'end' " class="fdm-progress-flap">
                        <mat-spinner style="margin:0 auto;display:inline;position:relative;left:-20px;" diameter="15" strokeWidth="3"></mat-spinner>
                        
                        <ng-container *ngIf="sceneController.callbacks[item.id] == 'start'">{{ 'MAP.PHOTOGRAM.PREPARING_DATA' | translate }}</ng-container>
                        <ng-container *ngIf="sceneController.callbacks[item.id] == 'init'">{{ 'TASK.START' | translate }}</ng-container>
                        <ng-container *ngIf="sceneController.callbacks[item.id] == 'process'">{{ 'PROCESSING.REMOTE' | translate }}</ng-container>
                        <ng-container *ngIf="sceneController.callbacks[item.id] == 'during'">{{ 'PROCESSING.JPG_3D' | translate }}</ng-container>
                        <!-- <ng-container *ngIf="sceneController.callbacks[item.id] == 'end'">Finished</ng-container> -->
                        
                        <!-- ({{ sceneController.callbacks[item.id] }}) -->
                      </span>

                      <ng-container *ngIf="mapService.scene['layerProps']['toggle_' + item.id]">
                        <fa-icon (click)="flyTo(item)" class="fdm-linked float-left" style="font-size:11px;padding:2px;opacity:0.8;" [matTooltip]="'MAP.FLY_TO' | translate" icon="paper-plane"></fa-icon>
                        <fa-icon *ngIf="!item['isTerrain'] && mapService.scene['layerProps']['toggle_' + item.id]" (click)="toggleView(item)" class="fdm-linked float-left" style="font-size:11px;padding:2px;opacity:0.8;" [class.fdm-layer-icon-gray]="!sceneTransformsActiveViews[item.id]" id='view-layer' [matTooltip]="'MAP.LAYERS.VISIBILITY' | translate" [icon]="sceneTransformsActiveViews[item.id] ? 'eye' : 'eye-slash'"></fa-icon>
                      
                        <ng-container *ngIf="transformPlugins">
                          <ng-container *ngFor="let opac of [transformPlugins.isActive(item,'colorizing-handler')]">
                            <span class="float-left" *ngIf="item['fdm_features'] && item['fdm_features']['canAlpha'] && mapService.isValidForChangingOpacity(item) &&mapService.scene['layerProps']['toggle_' + item.id]">
                              <fa-icon icon="sliders-h" class="fdm-linked" style="font-size:11px;padding:2px;opacity:0.8;" (mouseover)="togglePopslider(item.id, opac)"></fa-icon> 
                              <!-- <span style="font-size:9px;padding:0 3px;">{{ (opac ? opac.controls.opacity.value : mapService.scene['layerProps']['alpha_' + item.id]) * 100 | number}}%</span> -->
                              <div *ngIf="popslider == item.id" style="position:fixed;z-index:99;text-align:center;width:130px;margin-top:-21px;margin-left:-20px;height:24px;background-color:#def;border:solid 1px #aaa;" (mouseleave)="togglePopslider()">
                                <mat-slider color="primary" *ngIf="opac" class="fdm-layer-slider" min="0" max="1" step="0.01"
                                  [(ngModel)]="opac.controls.opacity.value" (input)="opac.controls.opacity.value = $event.value;opac.refresh();"
                                ></mat-slider> 
                                <mat-slider color="primary" *ngIf="!opac" class="fdm-layer-slider" min="0" max="1" step="0.01"
                                  [(ngModel)]="mapService.scene['layerProps']['alpha_' + item.id]" (input)="changeOpacity(item, _saveSubj, $event)"
                                ></mat-slider>
                              </div>
                            </span>
                          </ng-container>
                        </ng-container>

                      </ng-container>
                      
                      <!-- [{{ sceneController.callbacks[item.id] }}] -->

                      <!-- <ng-container *ngIf="item.__issues">
                        <ng-container *ngFor="let issue of item.__issues | keyvalue">
                          <fa-icon class="fdm-layer-icon fdm-layer-icon-issue" [icon]="issue.value.icon" *ngIf="!issue.value.isDismissed" (click)="issue.value.isShown = !issue.value.isShown"></fa-icon>
                        </ng-container>
                      </ng-container> -->

                      <!-- Layer plugins - icon shortcuts -->
                      <ng-container *ngFor="let shortcut of transformPlugins.listShortcuts(item)">
                        <fa-icon *ngIf="shortcut.show && mapService.scene['layerProps']['toggle_' + item.id]" [matTooltip]="shortcut['tooltip'] | translate" 
                        (click)="transformPlugins.component.clickPluginShortcut(shortcut,item,$event)" class="fdm-layer-icon" [class.fdm-icon-selected]="shortcut.active" [icon]="shortcut.icon"></fa-icon>
                      </ng-container>

                      <!-- Power cord / plug icon -->
                      <fa-icon *ngIf="transformPlugins && mapService.scene['layerProps']['toggle_' + item.id]" class="fdm-layer-icon" icon="plug" 
                        [class.fdm-icon-selected]="transformPlugins.getActiveCount(item)"
                        (mouseover)="transformPlugins.component.mouseHover(item,$event)" 
                        (mouseleave)="transformPlugins.component.mouseLeaveIcon(item,$event)" 
                        (click)="transformPlugins.component.mouseHoverClick(item,$event)"
                        id="layer-plugins"></fa-icon>

                    </ng-container>

                    <span style="margin-left:35px;float:left;color:#ccc;" *ngIf="splitViewer && splitViewer.isSplitting && item['canSplit']">
                      <ng-container *ngIf="splitViewer.leftSideTransform">
                        <fa-icon *ngIf="splitViewer.leftSideTransform.id == item.id" icon="dot-circle" class="fdm-annotation-color-green"></fa-icon>
                        <fa-icon *ngIf="splitViewer.leftSideTransform.id !== item.id && splitViewer.rightSideTransform.id !== item.id" icon="circle" class="fdm-linked" style="color:rgb(214, 233, 204);" (click)="splitViewer.updateLeftSide(item.id)"></fa-icon>
                        <fa-icon *ngIf="splitViewer.leftSideTransform.id !== item.id && splitViewer.rightSideTransform.id == item.id" icon="circle" style="color:#eee;"></fa-icon>
                      </ng-container> | 
                      <ng-container *ngIf="splitViewer.rightSideTransform">
                        <fa-icon *ngIf="splitViewer.rightSideTransform.id == item.id" icon="dot-circle" class="fdm-annotation-color-blue"></fa-icon>
                        <fa-icon *ngIf="splitViewer.rightSideTransform.id !== item.id && splitViewer.leftSideTransform.id !== item.id" icon="circle" class="fdm-linked" style="color:rgb(190, 213, 236);" (click)="splitViewer.updateRightSide(item.id)"></fa-icon>
                        <fa-icon *ngIf="splitViewer.rightSideTransform.id !== item.id && splitViewer.leftSideTransform.id == item.id" icon="circle" style="color:#eee;"></fa-icon>
                      </ng-container>
                    </span>

                    <!-- Layer options show/hide -->
                    <span class="fdm-show-options">
                      <fa-icon *ngIf="!item.showOptions && mapService.scene['layerProps']['toggle_' + item.id]" class="fdm-layer-icon-gray" icon="chevron-right" matTooltip="{{'GENERIC.OPTIONS' | translate }}" (click)="clickToggleViewDetails(item)"></fa-icon>
                      <fa-icon *ngIf="item.showOptions" class="fdm-layer-icon-gray" icon="chevron-left" matTooltip="{{'GENERIC.OPTIONS' | translate }}" (click)="clickToggleViewDetails(item)"></fa-icon>
                    </span>

                    <!-- terrain compare tool to be re-worked-->
                    <!-- <fa-icon *ngIf="item.type_uid == 'terrain-tiles' && mapService.scene['layerProps']['toggle_' + item.id]"
                            class="fdm-layer-icon" [icon]="['far','object-ungroup']"
                            [matTooltip]="'MAP.TERRAIN.COMPARE_TERRAIN' | translate"
                            [routerLink]="['terrainCompare',item.id]">
                    </fa-icon> -->
                
                  </div>

                  <!-- left-most items -->
                  <div class="fdm-layer-title" cdkDragHandle>

                    <ng-container *ngIf="!splitViewer || ( splitViewer && !splitViewer.isSplitting )">

                      <span class="fdm-checkboxes" *ngIf="permissions?.can?.toggle?.layer && ( item['isTerrain'] && sceneTerrainModels.length > 1 )">
                        <input [id]=" 'l' + item.id" name="sceneTerrains"
                              [disabled]="!permissions?.can?.toggle?.layer || item.status == 'failed' || sceneController.callbacks[item.id] == 'process' || sceneController.callbacks[item.id] == 'during'" 
                              class="fdm-radio fdm-linked" type="radio"
                              [checked]="item == sceneSelectedTerrainModel"
                              (click)="selectTerrainModel(item)" />
                      </span>

                      <span class="fdm-checkboxes" *ngIf="permissions?.can?.toggle?.layer && ( !item['isTerrain'] || ( item['isTerrain'] && sceneTerrainModels.length == 1 ) )">
                        <input [id]=" 'l' + item.id" 
                              [disabled]="!permissions?.can?.toggle?.layer || item.status == 'failed' || sceneController.callbacks[item.id] == 'process' || sceneController.callbacks[item.id] == 'during'" 
                              class="fdm-checkbox fdm-linked" type="checkbox"
                              [checked]="mapService.scene['layerProps']['toggle_' + item.id]"
                              (click)="toggle(item)" />
                        <label [for]=" 'l' + item.id"></label>
                      </span>

                    </ng-container>

                    <span class="fdm-checkboxes" *ngIf="!permissions?.can?.toggle?.layer || ( splitViewer && splitViewer.isSplitting )">
                      <fa-icon class="fdm-silent-icon"></fa-icon>
                    </span>

                    <span [matTooltip]="item.name || item.ds_name" [class.fdm-layer-title-disabled]="item.status == 'failed' || !mapService.scene['layerProps']['toggle_' + item.id]"
                            [class.fdm-linked]="mapService.scene['layerProps']['toggle_' + item.id]" (click)="flyTo(item)">
                        <fa-icon class="fdm-silent-icon" [fixedWidth]="true" [icon]="'ICON.' + (item.ds_type_uid || 'UNKNOWN') | translate"></fa-icon>
                        <!-- <fa-icon [fixedWidth]="true" icon="spinner" *ngIf="mapService.scene['layerProps']['toggle_' + item.id] && !isReady(item)"></fa-icon> -->
                        {{ item.name || item.ds_name }} 

                        <span *ngIf="mapService.scene['layerProps']['toggle_' + item.id] && item['__progress'] && item['__progress']['entity'] && item['__progress']['entity']['max']" class="fdm-progress-icon rotating flickering"><fa-icon icon="clock"></fa-icon><!-- {{ percent ( item['__progress']['entity']['max'], item['__progress']['entity']['current'] ) }}% --></span>
                        
                        <fa-icon class="accent" [fixedWidth]="true" icon="exclamation-triangle" *ngIf="item.status == 'failed'" [matTooltip]="item.desc"></fa-icon>
                        
                    </span>

                  </div>

                  <!-- because we're floating stuff, make sure we clear it all up -->
                  <div class="clearfix"></div>

                  <ng-container *ngFor="let plugin of transformPlugins.getActive(item)">
                    <ng-container *ngIf="plugin.calculating">
                      <mat-progress-bar style="margin:1px 0;width:342px;height:2px !important;" mode="buffer" [value]="plugin.calculatePercent" [matTooltip]="plugin.calculatePercent+'%'" color="accent"></mat-progress-bar><!--  {{plugin.calculatePercent | percent }}% -->
                    </ng-container>

                      
                  </ng-container>
                  
                  
                  <!-- <div [class]="'fdm-progress-slider ' + sceneController.callbacks[item.id]">
                    <span class="init"></span>
                    <span class="start"></span>
                    <span class="process"></span>
                    <span class="during"></span>
                    <span class="end"></span>
                  </div> -->

                  <!-- <div [@slideInOut] class="fdm-layer-loading"
                      *ngIf="(item.transformType.uid == 'kml' || item.transformType.uid == 'geo-json') && sceneController.callbacks[item.id] && sceneController.callbacks[item.id] !== 'end'">
                      <mat-spinner style="margin:0 auto;display:inline-block;" diameter="15" strokeWidth="3"></mat-spinner> {{ 'MAP.LAYERS.LOADING_KML' | translate }}
                  </div> -->

                  <ng-container *ngIf="item.__issues">
                    <ng-container *ngFor="let issue of item.__issues | keyvalue">
                      <div [@slideInOut] *ngIf="!issue.value.isDismissed" class="fdm-buttons" style="border:solid 2px #e5811a77;border-top:none;padding:10px;margin:2px 0;color:#999;">
                        <h6 style="color:#e5811a;font-size:13px;">
                          <fa-icon [icon]="issue.value.icon"></fa-icon> {{ issue.value.label }}
                        </h6>
                        <p *ngIf="issue.value.description">{{ issue.value.description }}</p>
                        <button *ngIf="issue.value.dismissIcon" mat-raised-button color="primary" class="float-right" (click)="dismissIssue(issue.value);item.saveObservable().subscribe();" matTooltip="Dismiss">
                          <fa-icon icon="thumbs-up" ></fa-icon> Got it!
                        </button>
                        <button *ngIf="issue.value.reportIcon && service.showContactUs() && !contactUsShow" mat-raised-button color="accent" class="float-right" (click)="clickReportIssue(issue.value)" matTooltip="Report">
                          <fa-icon icon="bug" ></fa-icon> Report it
                        </button>
                        <div class="clearfix"></div>

                        <!-- Contact us -->
                        <ng-container *ngIf="service.showContactUs()">

                          <div style="padding:0 10px 10px 10px" *ngIf="contactUsShow && contactUsRequest">
                            <ng-container *ngIf="contactUsState=='ready'">
                              <!-- <input *ngFor="let n of ['NAME','EMAIL','USER_ID','ACCOUNT_ID']" type="hidden" [name]="n" [value]="autoFill(n)" /> -->
                              
                              <h6>
                                Any additional info?
                                <span (click)="clickReportIssueDone();$event.stopPropagation()" class="fdm-linked float-right"><fa-icon icon="chevron-up"></fa-icon></span>
                              </h6>
                              <textarea [(ngModel)]="contactUsMessage" style="width:100%;font-size:11px;height:80px;color:#999;padding:5px;border:solid 1px orange;" (click)="$event.stopPropagation()"></textarea>
                              <button *ngIf="contactUsState=='ready'" (click)="clickReportIssueSend();$event.stopPropagation()">
                                <span class="fdm-linked"><fa-icon icon="arrow-right"></fa-icon> {{ 'MAP.GUIDES_DASHBOARD.CONTACT_US.SEND' | translate }}</span>
                              </button>
                            </ng-container>

                            <ng-container *ngIf="contactUsState=='sent' || contactUsState=='error'">
                              <div *ngIf="contactUsState=='sent'" class="alert">{{ 'MAP.GUIDES_DASHBOARD.CONTACT_US.SENT' | translate }}</div>
                              <div *ngIf="contactUsState=='error'" class="alert alert-danger">{{ 'MAP.GUIDES_DASHBOARD.CONTACT_US.SENT_ERROR' | translate }}</div>
                              <button>
                                <span (click)="clickReportIssueDone();$event.stopPropagation()" class="fdm-linked"><fa-icon icon="chevron-up"></fa-icon> {{ 'MAP.GUIDES_DASHBOARD.CONTACT_US.GO_BACK' | translate }} </span>
                              </button>
                            </ng-container>
                            
                            <mat-progress-bar color="accent" *ngIf="contactUsState=='sending'" class="mt-1" mode="indeterminate"></mat-progress-bar>
                            
                          </div>
                        </ng-container>

                      </div>
                    </ng-container>
                  </ng-container>

                  <!-- <ng-container *ngIf="item.__issues && item.__issues?.heightOffset">
                    <div [@slideInOut] *ngIf="!item.issues.heightOffset.isDismissed && item.issues.heightOffset.isOver && item.issues.heightOffset.isShown" style="border:solid 1px #f8e3a8;border-top:none;padding:15px;padding-top:7px;margin:2px 0;color:#999;">
                      The nearest surface to this layer is some distance away ({{ item.issues.heightOffset.offsetHeight }}m). You can change the height offset in the layer setting above, and you can <a href="#">read more</a> about it.
                      <fa-icon class="fdm-linked ml-1" icon='times' matTooltip="Dismiss" (click)="item.issues.heightOffset.isDismissed=true;item.saveObservable().subscribe();"></fa-icon>
                    </div>
                  </ng-container> -->

                  <!-- <div> active
                    <textarea style="width:100%;height:100px;font-size:9px;">{{ transformPlugins.listActive(item) | json }}</textarea>
                  </div> -->

                    <!-- <table *ngIf="mapService.scene['layerProps']['toggle_' + item.id]">
                      <tr>
                        <td colspan="3" class="fdm-plugin-box-back">
                          <b>Total</b>
                          <mat-chip [title]="pluginName" *ngFor="let pluginName of transformPlugins.listTotal(item)" class="fdm-link fdm-plugin-chip" color="primary">
                            {{ pluginManager.getLabelByName(pluginName) }}
                          </mat-chip>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3" class="fdm-plugin-box-back">
                          <b>Available</b>
                          <mat-chip [title]="pluginName" *ngFor="let pluginName of transformPlugins.listAvailable(item)" class="fdm-link fdm-plugin-chip" color="accent" selected 
                            (click)="transformPlugins.create(pluginName,item);">
                            {{ pluginManager.getLabelByName(pluginName) }} <fa-icon icon="plus-circle"></fa-icon>
                          </mat-chip>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3" class="fdm-plugin-box-back">
                          <b>Active</b>
                          <ng-container *ngFor="let pluginId of transformPlugins.listActive(item)">
                            <mat-chip [title]="pluginId" class="fdm-link fdm-plugin-chip"
                            (click)="transformPlugins.delete(pluginId,item);">
                              {{ pluginManager.getLabelById(pluginId) }} <fa-icon icon="minus-circle"></fa-icon>
                            </mat-chip>
                            <plugin-ui [plugin]="pluginManager.get(pluginId)" [item]="item" [context]="this"></plugin-ui>
                          </ng-container>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3" class="fdm-plugin-box-back">
                          <b>Shortcuts</b>
                          <ng-container *ngFor="let shortcut of transformPlugins.listShortcuts(item)">
                            <fa-icon (click)="clickPluginShortcut(shortcut,item,$event)" class="fdm-layer-icon" [class.fdm-icon-selected]="shortcut.active" [icon]="shortcut.icon"></fa-icon>({{ shortcut.show }})
                          </ng-container>
                          
                        </td>
                      </tr>
                    </table> -->

                    <!-- <fa-icon class="fdm-linked ml-1" icon='cog' matTooltip="Check" (click)="checkLayers();"></fa-icon> -->

                    <!-- <div *ngIf="item?.issues?.heightOffset?.isOver && !item?.issues?.heightOffset?.isDismissed" style="border:solid 1px #f8e3a8;border-top:none;padding:15px;padding-top:7px;margin:2px 0;color:#999;">
                      The nearest surface to this layer is some distance away ({{ item.issues.heightOffset.offsetHeight }}m). You can change the height offset in the layer setting above, and you can <a href="#">read more</a> about it.
                      <fa-icon class="fdm-linked ml-1" icon='times' matTooltip="Dismiss" (click)="item.issues.heightOffset.isDismissed=true;item.saveObservable().subscribe();"></fa-icon>
                    </div> -->

                    <!-- <div *ngIf="item?.issues?.heightOffset?.isOver && item?.issues?.heightOffset?.isDismissed" style="border:solid 1px #d4d6d7;border-top:none;padding:15px;padding-top:7px;margin:2px 0;color:#999;">
                      Issue dealt with.
                      <fa-icon class="fdm-linked ml-1" icon='times' matTooltip="Bring back" (click)="item.issues.heightOffset.isDismissed=false;item.saveObservable().subscribe();"></fa-icon>
                    </div> -->

                  <!-- Show layer options-->
                  <div *ngIf="item.showOptions" [@slideInOut] class="fdm-sidebar-scene-layer-props">

                    <div class="header">
                      <fa-icon class="fdm-linked fdm-text-large float-right" icon="times-circle" (click)="clickToggleViewDetails(item)" id="layer-options"></fa-icon>
                      <span class="title" style="display:contents">
                        <fa-icon class="fdm-silent-icon" [fixedWidth]="true" [icon]="'ICON.' + (item.ds_type_uid || 'UNKNOWN') | translate"></fa-icon> {{item.name}}
                      </span>
                    </div>

                    <!-- Download layer-->
                    <div class="fdm-sidebar-toolbar">
                      <span class="fdm-meta-action fdm-link" *ngIf="permissions?.can?.download?.layer && item?.input" id="download-layer" [matTooltip]="'GENERIC.DOWNLOAD' | translate">
                        <a vlink="data" [model]="item.input">
                          <fa-icon icon="download" class="fdm-layer-icon"></fa-icon>
                          <b>{{ 'GENERIC.DOWNLOAD' | translate }}</b>
                        </a>
                      </span>

                      <!-- Reset layer -->
                      <span class="fdm-meta-action fdm-link" (click)="resetTransform(item)" id="reset-layer" [matTooltip]="'GENERIC.RESET' | translate">
                        <fa-icon icon="power-off" class="fdm-layer-icon fdm-annotation-color-orange"></fa-icon>
                        <b>{{ 'GENERIC.RESET' | translate }}</b>
                      </span>

                      <!-- Camera bookmark -->
                      <!-- <span class="fdm-meta-action fdm-link" (click)="openCameraBookmarks())">
                        <fa-icon icon="power-off" class="fdm-layer-icon fdm-annotation-color-orange"></fa-icon>
                        <b>{{ 'GENERIC.RESET' | translate }}</b>
                      </span> -->

                      <!-- Delete layer -->
                      <span class="fdm-meta-action fdm-link float-right" (click)="deleteFromScene(item)" *ngIf="permissions?.can?.delete?.layer" id="delete-layer" [matTooltip]="'GENERIC.DELETE' | translate">
                        <fa-icon icon="trash" class="fdm-layer-icon danger"></fa-icon>
                        <b>{{ 'GENERIC.DELETE' | translate }}</b>
                      </span>
                    </div>

                    <div class="content">
                      <table class="fdm-metadata" style="border-collapse: separate;  border-spacing: 10px 0px;">

                        <!-- <tr style="background-color:#ccc;"><td colspan="3">

                          <span class="fdm-meta-action fdm-link" *ngIf="permissions?.can?.download?.layer && item?.input" [matTooltip]="'GENERIC.DOWNLOAD' | translate">
                            <a vlink="data" [model]="item.input">
                              <fa-icon icon="download" class="fdm-layer-icon"></fa-icon>
                              <b>{{ 'GENERIC.DOWNLOAD' | translate }}</b>
                            </a>
                          </span>

                          <span class="fdm-meta-action fdm-link" (click)="resetTransform(item)" [matTooltip]="'' | translate">
                            <fa-icon icon="power-off" class="fdm-layer-icon warn"></fa-icon>
                            <b>{{ 'GENERIC.RESET' | translate }}</b>
                          </span>

                          <span class="fdm-meta-action fdm-link" (click)="deleteFromScene(item)" *ngIf="permissions?.can?.delete?.layer" [matTooltip]="'GENERIC.DELETE' | translate">
                            <fa-icon icon="trash" class="fdm-layer-icon danger"></fa-icon>
                            <b>{{ 'GENERIC.DELETE' | translate }}</b>
                          </span>

                        </td></tr> -->


                        <tr *ngIf="item.status == 'failed'" class="fdm-metadata-header-topspace accent"><td colspan="3">{{'FILE_LIST.TILING_WIZARD.FAILED_PROCESSING' | translate }}</td></tr>
    
                        <tr *ngIf="item.status == 'failed'" >
                          <td>{{'FILE_LIST.TILING_WIZARD.REASON' | translate }}</td>
                          <td colspan="2">{{item.desc}}</td>
                        </tr>
    
                        <!-- General file information-->

                        <tr><td colspan="3"></td></tr>

                        <tr class="fdm-metadata-header-topspace" id="file-info"><td colspan="3">{{ 'MAP.LAYERS.FILE_DETAILS' | translate }}</td></tr>
                        
                        <!-- File ID -->
                        <tr>
                          <td>{{ 'MAP.LAYERS.FILE_ID' | translate }}</td>
                          <td colspan="2">{{item.id}}</td>
                        </tr>
                        <tr>
                          <td>{{ 'MAP.LAYERS.FILE_NAME' | translate }}</td>
                          <td colspan="2" style="white-space:nowrap;overflow-x:hidden;max-width:250px;">
                            <ng-container *ngIf="permissions?.can?.edit?.layer"><input type="text" [ngModel]="item?.name || item.ds_name" (blur)="saveLayerName(item, $event.target.value)"></ng-container>
                            <ng-container *ngIf="!permissions?.can?.edit?.layer">{{ item.name || item.ds_name }}</ng-container>
                          </td>
                        </tr>

                        <!-- File type-->
                        <tr>
                          <td>{{ 'MAP.LAYERS.FILE_TYPE' | translate }}</td>
                          <td colspan="2"><b>{{item.type_uid}}</b> &nbsp; <span style="color:#bbb;">({{item.ds_type_uid}})</span></td>
                        </tr>

                        <!-- Entity type -->
                        <tr>
                          <td>{{ 'MAP.LAYERS.ENTITY_TYPE' | translate }}</td>
                          <td colspan="2"><b>{{ isEntityType(item) }}</b></td>
                        </tr>

                        <!-- SDK renderer -->
                        <tr *ngIf="item['__renderer']">
                          <td>{{ 'MAP.LAYERS.RENDERER' | translate }}</td>
                          <td colspan="2"><b>{{ item['__renderer'] }}</b></td>
                        </tr>

                        <!-- Date uploaded -->
                        <tr>
                          <td>{{ 'MAP.LAYERS.FILE_UPLOADED' | translate }}</td>
                          <td colspan="2">{{item.dateMade | dateAgo | async }}</td>
                        </tr>
    
                        <!--<tr>
                          <td>{{'MAP.PHOTOGRAM.SELECTED_EPSG_CODE' | translate }}</td>
                          <td colspan="2">       <span *ngIf="selectedEPSGCode"> {{selectedEPSGCode.name}} </span>
                            <span *ngIf="!selectedEPSGCode"> {{ 'MAP.PHOTOGRAM.NONE_SELECTED' | translate }} </span></td>
                        </tr>
                      -->

                      

                        <!-- Adjustments -->
                        <tr><td colspan="3"></td></tr>
                        <tr class="fdm-metadata-header-topspace" id="adjust-layer"><td colspan="3">{{ 'MAP.LAYERS.ADJUSTMENTS' | translate }}</td></tr>
    
                        <!-- Add color -->
                        <tr *ngIf="item.transformType.uid == 'three-d-tiles' && !(item.ds_type_uid == 'laslaz'  || item.ds_type_uid == 'laslaz-tiles')">
                          <td> {{ 'MAP.LAYERS.COLOR' | translate }}</td>
                          <td colspan="2" style="vertical-align:top;text-align:left;">
                            
                            <div class="fdm-circle-choice fdm-annotation-color-white fdm-annotation-background-color-orange" 
                            [(colorPicker)]="item['color']" 
                            (colorPickerChange)="tilesetColor(item, item['color'])" 
                            [style.background]="getTilesetColor(item)" 
                            cpOutputFormat="rgba" 
                            cpPosition="bottom"
                            cpPositionOffset="50%"
                            [cpPositionRelativeToArrow]="true"
                            matTooltip="{{ 'MAP.LAYERS.ADD_COLOR' | translate }}">
                              <fa-icon icon="chevron-down"></fa-icon>
                            </div>   
                            <!--<span style="float:right;color:#999;font-size:9px;">(temporary)</span> -->
                          
                          </td>
                        </tr>
    
                        <!-- Height adjustment -->
    
                        <tr *ngIf="item.transformType.uid == 'three-d-tiles'">
                          <td>{{ 'GENERIC.HEIGHT' | translate }}</td>
                          <td>
                            <input size="3" matInput type="number" min="-300" max="300" [(ngModel)]="item.vertical_offset" (input)="updateHeight(item, item.vertical_offset)">
                          </td>
                          <td>
                            <mat-slider color="primary" class="fdm-layer-slider" min="-100" max="100" step="1"
                                      [(ngModel)]="item.vertical_offset"
                                      (input)="updateHeight(item, $event.value);" matTooltip="{{ 'MAP.LAYERS.ADJUST_HEIGHT' | translate }}"></mat-slider>
                          </td>
                        </tr>
    
                        <!-- Opacity -->
    
                        <tr *ngIf="item['fdm_features'] && item['fdm_features']['canAlpha'] && mapService.isValidForChangingOpacity(item)">
                          <td>{{ 'MAP.LAYERS.OPACITY' | translate }}</td>
                          <td>
                            <input size="3" matInput type="number" min="0" step="0.02" max="1" [(ngModel)]="mapService.scene['layerProps']['alpha_' + item.id]" (input)="changeOpacity(item)">
                          </td>
                          <td>
                            <mat-slider color="primary"
                              class="fdm-layer-slider" min="0" max="1" step="0.01"
                              [(ngModel)]="mapService.scene['layerProps']['alpha_' + item.id]"
                              (input)="changeOpacity(item, _saveSubj, $event)"
                              matTooltip="{{ 'MAP.LAYERS.ADJUST_OPACITY' | translate }}"></mat-slider>
                          </td>
                        </tr>

                        <!-- <tr><td>Loading state</td><td colspan="2"><span *ngIf="sceneController.callbacks[item.id]">[{{ sceneController.callbacks[item.id] }}]</span></td></tr> -->
    
                        <!-- Add wireframe-->
                        <tr  *ngIf="item.transformType.uid == 'three-d-tiles' && item.ds_type_uid != 'laslaz'">
                          <td>{{ 'MAP.LAYERS.WIREFRAME' | translate }}</td>
                          <td colspan="2">
                            
                            <mat-checkbox class="float-left" [(ngModel)]="item['wireframe']" (change)="tilesetWireframe(item, item['wireframe'])" matTooltip="{{ 'MAP.LAYERS.ADD_WIREFRAME' | translate }}"></mat-checkbox> 
                            <!--<span style="float:right;color:#999;font-size:9px;">(temporary)</span> -->
                          </td>
                        </tr>

                        <ng-container *ngIf="item.transformType.uid == 'kml' || item.transformType.uid == 'geo-json'">
                          <!-- Loading of GeoJSON / KML / shapefiles -->
                          <!-- <tr>
                            <td colspan="3">
                              <div [@slideInOut] class="fdm-layer-loading"
                                  *ngIf="(item.transformType.uid == 'kml' || item.transformType.uid == 'geo-json') && sceneController.callbacks[item.id] && sceneController.callbacks[item.id] !== 'ready'">
                                  <mat-spinner style="margin:0 auto;display:inline-block;" diameter="15" strokeWidth="5"></mat-spinner> {{ 'MAP.LAYERS.LOADING_KML' | translate }}
                              </div>
                            </td>
                          </tr> -->
                          <!-- Clamping of GeoJSON / KML / shapefiles -->
                          <tr>
                            <td>{{ 'MAP.LAYERS.CLAMPING' | translate }}</td>
                            <td colspan="2">
                              <mat-checkbox class="float-left" [(ngModel)]="item['clamping']" (change)="itemClamping(item, item['clamping'])" matTooltip="{{ 'MAP.LAYERS.TOGGLE_CLAMPING' | translate }}"></mat-checkbox> 
                              <mat-spinner *ngIf="sceneController.callbacks[item.id] && sceneController.callbacks[item.id] !== 'end'" style="margin:-5px 0 0 10px;display:inline-block;" diameter="25" strokeWidth="3"></mat-spinner> 
                            </td>
                          </tr>
                        </ng-container>
                        
    
                        

                        <!-- various options for imageLayers -->
                        
                        <ng-container *ngIf="item.fdm_features && (item.fdm_features.entityType == 'ImageryLayer' ||  item.transformType?.name == 'TMS')">
    
                          <!-- Contrast -->
                          <tr>
                            <td>{{ 'MAP.LAYERS.CONTRAST' | translate }}</td>
                            <td>
                              <input size="3" matInput type="number" min="0" step="0.1" max="3" [(ngModel)]="mapService.scene['layerProps']['contrast_' + item.id]" (input)="changeContrast(item)">
                            </td>
                            <td>
                              <mat-slider color="primary"
                                class="fdm-layer-slider" min="0" max="3" step="0.05"
                                [(ngModel)]="mapService.scene['layerProps']['contrast_' + item.id]"
                                (input)="changeContrast(item, _saveSubj, $event)" matTooltip="{{ 'MAP.LAYERS.ADJUST_CONTRAST' | translate }}"
                              ></mat-slider>
                            </td>
                          </tr>
        
                          <!-- Brightness-->
                          <tr>
                            <td>{{ 'MAP.LAYERS.BRIGHTNESS' | translate }}</td>
                            <td>
                              <input size="3" matInput type="number" min="0" step="0.1" max="3" [(ngModel)]="mapService.scene['layerProps']['brightness_' + item.id]" (input)="changeBrightness(item)">
                            </td>
                            <td>
                              <mat-slider color="primary"
                                class="fdm-layer-slider" min="0" max="3" step="0.05"
                                [(ngModel)]="mapService.scene['layerProps']['brightness_' + item.id]"
                                (input)="changeBrightness(item, _saveSubj, $event)" matTooltip="{{ 'MAP.LAYERS.ADJUST_BRIGHTNESS' | translate }}"                     ></mat-slider>
                            </td>
                          </tr>
        
                          <!-- Saturation -->
                          <tr>
                            <td>{{ 'MAP.LAYERS.SATURATION' | translate }}</td>
                            <td>
                              <input size="3" matInput type="number" min="0" step="0.1" max="3" [(ngModel)]="mapService.scene['layerProps']['saturation_' + item.id]" (input)="changeSaturation(item)">
                            </td>
                            <td>
                              <mat-slider color="primary"
                                class="fdm-layer-slider" min="0" max="3" step="0.05"
                                [(ngModel)]="mapService.scene['layerProps']['saturation_' + item.id]"
                                (input)="changeSaturation(item, _saveSubj, $event)" matTooltip="{{ 'MAP.LAYERS.ADJUST_SATURATION' | translate }}"
                              ></mat-slider>
                            </td>
                          </tr>
        
                          <!-- Gamma -->
                          <tr>
                            <td>{{ 'MAP.LAYERS.GAMMA' | translate }}</td>
                            <td>
                              <input size="3" matInput type="number" min="0" step="0.1" max="3" [(ngModel)]="mapService.scene['layerProps']['gamma_' + item.id]" (input)="changeGamma(item)">
                            </td>
                            <td>
                              <mat-slider color="primary"
                                class="fdm-layer-slider" min="0" max="3" step="0.05"
                                [(ngModel)]="mapService.scene['layerProps']['gamma_' + item.id]"
                                (input)="changeGamma(item, _saveSubj, $event)" matTooltip="{{ 'MAP.LAYERS.ADJUST_GAMMA' | translate }}"
                              ></mat-slider>
                            </td>
                          </tr>
    
                        </ng-container>
    
                        <!-- <ng-container *ngIf="item.fdm_features">
                          <tr>
                            <td>Typecasting</td>
                            <td colspan="2">
                              <textarea style="width:100%;height:100px;font-size:8px;">{{ item.fdm_features | json }}</textarea>
                            </td>
                          </tr>
                        </ng-container> -->
    
                      <!-- PointCloud shading 
                        <ng-container *ngIf="item?.pointCloudShading">
                          <tr class="fdm-metadata-header-topspace" id="shading-layer"><td colspan="3">{{ 'MAP.LAYERS.POINTCLOUD_SHADING' | translate }}</td></tr>
                        
                          <tr *ngIf="item.pointCloudShading?.baseResolution">
                            <td>{{ 'MAP.LAYERS.BASE_RESOLUTION' | translate }}</td>
                            <td colspan="2">{{item.pointCloudShading.baseResolution}}</td>
                          </tr>

                          <tr *ngIf="item.pointCloudShading?.attenuation">
                              <td>{{ 'MAP.LAYERS.ATTENUATION' | translate }}</td>
                              <td colspan="2">{{item.pointCloudShading.attenuation}}</td>
                          </tr>

                          <tr *ngIf="item.pointCloudShading?.maximumAttenuation">
                              <td>{{ 'MAP.LAYERS.MAX_ATTENUATION' | translate }}</td>
                              <td colspan="2">{{item.pointCloudShading.maximumAttenuation}}</td>
                          </tr>
    
                        </ng-container> -->
    
                        <!-- <tr><td colspan="3"></td></tr>
                        <tr class="fdm-metadata-header-topspace"><td colspan="3">{{ 'MAP.ACTIONS' | translate }}</td></tr> -->
    
                        <!-- Properties -->
                        <tr><td colspan="3"></td></tr>
                        <tr class="fdm-metadata-header-topspace" id="properties-layer"><td colspan="3">{{ 'MAP.LAYERS.PROPERTIES' | translate }} ({{ objectPropertyCount(item) }})
                          <ng-container *ngIf="objectPropertyCount(item)">
                            <fa-icon *ngIf="!item.showProperties" class="fdm-layer-icon-gray" icon="chevron-down" (click)="item['showProperties'] = !item['showProperties']"></fa-icon>
                            <fa-icon *ngIf="item.showProperties" class="fdm-layer-icon-gray" icon="chevron-up" (click)="item['showProperties'] = !item['showProperties']"></fa-icon>
                          </ng-container>
                        </td></tr>
                        <ng-container *ngIf="item['showProperties']">
                          <tr *ngFor="let op of objectProperty(item) | keyvalue">
                            <td style="background-color:#ddd;">{{ op.key }}</td>
                            <td colspan="2">{{ op.value }}</td>
                          </tr>
                        </ng-container>

                        <!-- Entities -->
                        <tr><td colspan="3"></td></tr>
                        <tr class="fdm-metadata-header-topspace" id="entities-layer"><td colspan="3">{{ 'MAP.LAYERS.ENTITIES' | translate }} ({{ objectEntityCount(item) }})
                          <ng-container *ngIf="objectEntityCount(item)">
                            <fa-icon *ngIf="!item.showEntities" class="fdm-layer-icon-gray" icon="chevron-down" (click)="item['showEntities'] = !item['showEntities']"></fa-icon>
                            <fa-icon *ngIf="item.showEntities" class="fdm-layer-icon-gray" icon="chevron-up" (click)="item['showEntities'] = !item['showEntities']"></fa-icon>
                          </ng-container>
                        </td></tr>
                        <ng-container *ngIf="item['showEntities']">
                          <tr *ngFor="let op of objectEntities(item) | keyvalue">
                            <td colspan="3">
                              
                              <table class="fdm-prop-table" *ngIf="op.key == 'types'">
                                <tr><td colspan="2" class="fdm-prop-header">{{ 'MAP.LAYERS.TYPES' | translate }}</td></tr>
                                <tr>
                                  <th>{{ 'MAP.LAYERS.TYPE' | translate }}</th>
                                  <th>{{ 'MAP.LAYERS.COUNT' | translate }}</th>
                                </tr>
                                <tr *ngFor="let opp of op.value | keyvalue">
                                  <td><span class="fdm-prop-key">{{ opp.key }}</span></td>
                                  <td><span class="fdm-prop-value">{{ opp.value }}</span></td>
                                </tr>
                              </table>
                              <table class="fdm-prop-table" *ngIf="op.key == 'children'">
                                <tr><td colspan="2" class="fdm-prop-header">Children</td></tr>
                                <tr>
                                  <th>{{ 'MAP.LAYERS.TYPE' | translate }}</th>
                                  <th>{{ 'MAP.LAYERS.COUNT' | translate }}</th>
                                </tr>
                                <tr *ngFor="let opp of op.value | keyvalue">
                                  <td><span class="fdm-prop-key">{{ opp.key }}</span></td>
                                  <td><span class="fdm-prop-value">{{ opp.value }}</span></td>
                                </tr>
                              </table>
                              <table class="fdm-prop-table" *ngIf="op.key == 'properties'">
                                <tr><td colspan="3" class="fdm-prop-header">{{ 'MAP.LAYERS.PROPERTIES' | translate }}</td></tr>
                                <tr>
                                  <th>{{ 'MAP.LAYERS.PROPERTY' | translate }}</th>
                                  <th>{{ 'MAP.LAYERS.COUNT' | translate }}</th>
                                  <th>{{ 'MAP.LAYERS.COUNT_UNIQUE' | translate }}</th>
                                </tr>
                                <tr *ngFor="let opp of op.value | keyvalue">
                                  <td><span class="fdm-prop-key">{{ opp.key }}</span></td>
                                  <td><span class="fdm-prop-value">{{ opp.value.count }}</span></td>
                                  <td><span class="fdm-prop-value">{{ opp.value.unique }}</span></td>
                                </tr>
                              </table>
                            </td>
                            <!-- <td colspan="2" *ngIf="op.key == 'types'">
                              <div *ngFor="let opp of op.value | keyvalue">
                                <span class="fdm-prop-key">{{ opp.key }}</span>
                                <span class="fdm-prop-value">found {{ opp.value }}</span>
                              </div>
                            </td>
                            <td colspan="2" *ngIf="op.key == 'properties'">
                              <div *ngFor="let opp of op.value | keyvalue">
                                <span class="fdm-prop-key">{{ opp.key }}</span>
                                <span class="fdm-prop-value">has {{ opp.value.unique }} unique values in {{ opp.value.count }} entities</span>
                              </div>
                            </td> -->
                          </tr>
                        </ng-container>


                        <!-- Layer plugins -->
                        <ng-container *ngIf="transformPlugins && mapService.scene['layerProps']['toggle_' + item.id]">
                          <tr class="fdm-metadata-header-topspace" id="plugins-layer"><td colspan="3">{{ 'MAP.LAYERS.PLUGINS' | translate }}</td></tr>
                          <tr>
                            <td colspan="3" class="fdm-plugin-box-back">
                              <mat-chip [title]="pluginName" *ngFor="let pluginName of transformPlugins.listAvailable(item)" class="fdm-link fdm-plugin-chip" color="accent" selected 
                              (click)="transformPlugins.create(pluginName,null,item);">
                              {{ pluginManager.getLabelByName(pluginName) | translate }} <fa-icon icon="plus-circle"></fa-icon>
                            </mat-chip>
                            </td>
                          </tr>
                          <tr *ngFor="let pluginId of transformPlugins.listActive(item)">
                            <td colspan="3" class="fdm-plugin-box-back">
                              <plugin-ui [plugin]="pluginManager.get(pluginId)" [item]="item" [context]="this"></plugin-ui>
                            </td>
                          </tr>
                        </ng-container>
    
                        <!-- <tr>
                          <td>{{ 'GENERIC.RESET' | translate }}</td>
                          <td colspan="2">
                            <fa-icon icon="power-off" class="fdm-layer-icon danger" (click)="resetTransform(item)"></fa-icon>
                          </td>
                        </tr> -->
    
                        <!-- <tr *ngIf="permissions?.can?.download?.layer && item?.input">
                          <td>{{ 'GENERIC.DOWNLOAD' | translate }}</td>
                          <td colspan="2">
                            <a vlink="data" [model]="item.input">
                              <fa-icon icon="download" class="fdm-layer-icon"></fa-icon>
                            </a>
                          </td>
                        </tr> -->
    
                        <!-- <tr *ngIf="permissions?.can?.delete?.layer">
                          <td>{{ 'GENERIC.DELETE' | translate }}</td>
                          <td colspan="2">
                            <fa-icon icon="trash" class="fdm-layer-icon danger" (click)="deleteFromScene(item)"></fa-icon>
                          </td>
                        </tr> -->
    
                        <!-- <tr>
                          <td>Inspect</td>
                          <td colspan="2">
                            <fa-icon icon="folder" class="fdm-layer-icon" (click)="inspectItem(item)"></fa-icon>
                          </td>
                        </tr> -->
    
                      </table>
    
                    </div>

                  </div>

                </li>

              </ng-container>

            </ng-container>
            
            <!-- No layers message -->
            <li [@slideInOut] *ngIf="mapService.sceneTransforms.length == 0">
              <div class="mt-2 alert" style="padding:30px 20px !important;background-color:#ffeac6;">

                <button (click)="clickAddData()" id="add-data" class="fdm-force-color-accent float-right" style="padding:5px !important;margin-left:7px;width:65px;" color="accent" mat-raised-button>
                  <fa-icon [icon]="['far','layer-plus']" style="font-size:27px;"></fa-icon>
                  <div translate style="margin-top:-5px;">MAP.ADD_DATA2</div>
                </button>
                {{ 'MAP.MODES.LAYER_BLANK' | translate }}

                <div class="clearfix" style="margin-bottom:30px;padding-bottom:30px;border-bottom:solid 1px #ffffff99;"></div>

                <!-- Quick guides icon -->
                <button (click)="uiManager.toggleQuickGuidePopup('map', true)" class="fdm-force-color-accent float-right" style="padding:5px !important;margin-left:7px;width:65px;" color="accent" mat-raised-button [matTooltip]="'NAV.QUICK_GUIDES' | translate">
                  <fa-icon [icon]="['far','question-circle']" style="font-size:27px;"></fa-icon>
                  <div translate style="margin-top:-5px;">MAP.MODES.GUIDES</div>
                </button>
                {{ 'MAP.MODES.LAYER_BLANK_GUIDES' | translate }}
                <span class="fdm-linked" (click)="uiManager.clickQuickGuides('MAP.MODES.GUIDE_PHOTOGRAMMETRY')" translate>MAP.MODES.GUIDE_PHOTOGRAMMETRY</span>

                <div class="clearfix"></div>
              </div>
            </li>

            <!-- Shapes -->
            <!-- <ng-container *ngIf="false">
              <li class="fdm-sidebar-scene-layer">
                <div class="fdm-layer-title fdm-link fdm-layer-section-title">
                  {{ 'MAP.LAYERS.SHAPES' | translate }} <i>{{ mapService?.sceneShapes?.length }}</i>
                </div>
                <div class="clearfix"></div>
              </li>

              <ng-container *ngIf="!loading">
                <li *ngFor="let i of mapService.sceneShapes; let idx = index">
                  <div class="fdm-layer-title">
                    <span class="fdm-checkboxes">
                      <input [id]=" 'so' + idx" type="checkbox" class="fdm-checkbox" [(ngModel)]="i.show" />
                      <label [for]=" 'so' + idx"></label>
                    </span>

                    <span [class.fdm-layer-title-disabled]="!i.show" [class.fdm-linked]="i.show">
                      <fa-icon class="fdm-silent-icon" [icon]="i.icon"></fa-icon>
                      {{ i.label }}
                    </span>
                  </div>
                  <div class="clearfix"></div>
                </li>
              </ng-container>
            </ng-container> -->

          </ul>

          <div *ngIf="editing" class="clearfix" style="padding:8px 10px;">
            <button (click)="editing = !editing" mat-flat-button color="primary" class="float-right">
              <fa-icon icon="check"></fa-icon>
              {{ 'GENERIC.DONE' | translate }}
            </button>
          </div>

        </div>

      </li>
    <!-- </ng-container> -->

  </ul>


  <xs-widget-popover [pluginController]="transformPlugins" [context]="this"></xs-widget-popover>

  <!-- <div *ngFor="let pl of sceneController.activeCameraPositions | keyvalue">
    <b *ngIf="pl.key != 'counter'">[{{ pl.key }}]</b>
    <ng-container *ngIf="pl.key != 'counter' && pl.value && pl.value.length">
      <li *ngFor="let c of pl.value">
        [{{ c.id }}] 
        G=[{{ c.data.global.camera ? true : false }}] 
        U=[{{ c.data.user.camera ? true : false }}] 
      </li>
    </ng-container>
  </div>

  <hr>

  <li *ngFor="let pl of sceneController.plottedTransforms">
    [{{ pl.id }}] {{ pl.name }}
  </li> -->

</div>

<div class="fdm-sidebar-tabs-body" *ngIf="uiManager.uiMode == 'simple'" style="padding:30px 10px 0 20px;">

  <ul class="fdm-sidebar-list-simple">

    <div class="mt-4 w-100 text-center" *ngIf="loading">
      <mat-spinner style="margin:0 auto;" strokeWidth="3"></mat-spinner>
    </div>

    <fdm-buckets class="bucket" *ngIf="sceneBuckets" [controller]="sceneBuckets"></fdm-buckets>

    <li *ngIf="mapService?.scene" class="fdm-sidebar-scene-layer listable bucket" style="font-size:15px;padding:3px 5px;">

      <!-- Delete photos -->

      <fa-icon icon="trash" class="fdm-layer-icon danger float-right"
               *ngIf="editing && mapService.scene?._photo_count > 0" (click)="nukePhotos()"></fa-icon>

      <div class="fdm-layer-tools" *ngIf="!editing">

        <!-- Photo tools -->
        <mat-slide-toggle id="guide-open-photo-bucket" (click)="clickPhotoBucket();" *ngIf="mapComponent && mapComponent?.photosNav" 
          class="float-right mat-slide-toggle-atomic" color="primary" matTooltip="{{ 'MAP.VIEW_PHOTOS' | translate }}" [checked]="mapComponent.photosNav.opened">
        </mat-slide-toggle>

      </div>

      <div class="fdm-layer-title">

        <!-- View the photos -->

        <span class="fdm-checkboxes">
          <input [id]=" 'l' + mapService.scene.id"
                type="checkbox" class="fdm-checkbox"
                [(ngModel)]="mapService.showPhotos[mapService.scene.id]" (change)="showHidePhotos($event)"/>
          <label [for]=" 'l' + mapService.scene.id"></label>
        </span>

        <!-- Photos -->
        <span [class.fdm-layer-title-disabled]="!mapService.showPhotos[mapService.scene.id]"
              [class.fdm-linked]="mapService.showPhotos[mapService.scene.id]"
              (click)="flyToPhotos()"
        >
          <fa-icon class="fdm-silent-icon" icon="camera" ></fa-icon>
          {{ 'MAP.PHOTO_COUNT' | translate }} <i>{{ mapService.scene?._photo_count }}</i>
        </span>
      </div>

      <!-- Because we're floating stuff, make sure we clear it all up -->

      <div class="clearfix"></div>

    </li>


    <ng-container *ngFor="let item of sceneTransforms">

      <ng-container *ngIf="( uiManager.uiModeHideSimple && mapService.scene['layerProps']['toggle_' + item.id] ) || !uiManager.uiModeHideSimple">
      
        <li class="fdm-sidebar-scene-layer listable" style="font-size:15px;padding:3px 5px;" [class.fdm-hover-main]="measureHelper?.pickedModel?.primitive?.transform_id == item.id">

          <!-- Layer options -->
            <div class="fdm-layer-tools" style="color:#999;font-size:12px;width:50px;">

              <!-- Layer plugins - icon shortcuts -->
              <ng-container *ngFor="let shortcut of transformPlugins.listShortcuts(item)">
                <fa-icon *ngIf="shortcut.show && mapService.scene['layerProps']['toggle_' + item.id]" [matTooltip]="shortcut['tooltip'] | translate" 
                (click)="transformPlugins.component.clickPluginShortcut(shortcut,item,$event)" class="fdm-layer-icon" [class.fdm-icon-selected]="shortcut.active" [icon]="shortcut.icon"></fa-icon>
              </ng-container>

              <!-- Power cord / plug icon -->
              <fa-icon *ngIf="transformPlugins && mapService.scene['layerProps']['toggle_' + item.id]" class="fdm-layer-icon" icon="plug" 
                [class.fdm-icon-selected]="transformPlugins.getActiveCount(item)"
                (mouseover)="transformPlugins.component.mouseHover(item,$event)" 
                (mouseleave)="transformPlugins.component.mouseLeaveIcon(item,$event)" 
                (click)="transformPlugins.component.mouseHoverClick(item,$event)"
                id="layer-plugins"></fa-icon>

              <!-- <span class="fdm-show-options">
                <fa-icon *ngIf="!item.showOptions && mapService.scene['layerProps']['toggle_' + item.id]" class="fdm-layer-icon-gray" icon="chevron-down" matTooltip=" {{'GENERIC.OPTIONS' | translate }}" (click)="item.showOptions = true"></fa-icon>
                <fa-icon *ngIf="item.showOptions" class="fdm-layer-icon-gray" icon="chevron-up" matTooltip="{{'GENERIC.OPTIONS' | translate }}" (click)="item.showOptions = false"></fa-icon>
              </span> -->
            </div>

            <div  class="fdm-layer-title" style="width:240px;">

              <span class="fdm-checkboxes" *ngIf="mapService.scene['layerProps']['toggle_' + item.id]">
                <input [id]=" 'vt' + item.id" class="fdm-checkbox fdm-linked" type="checkbox"
                  [checked]="sceneTransformsActiveViews[item.id]"
                  (click)="toggleView(item)" />
                <label [for]=" 'vt' + item.id"></label>
              </span>
              
              <span class="fdm-checkboxes" *ngIf="!mapService.scene['layerProps']['toggle_' + item.id]">
                <label [for]=" 'vt' + item.id"></label>
                <fa-icon class="fdm-silent-icon" style="display:inline-block;width:16px;"></fa-icon>
              </span>
          
              <span [matTooltip]="item.name || item.ds_name" [class.fdm-layer-title-disabled]="!mapService.scene['layerProps']['toggle_' + item.id]"
                    [class.fdm-linked]="mapService.scene['layerProps']['toggle_' + item.id]" (click)="flyTo(item)">
                  <fa-icon class="fdm-silent-icon" [fixedWidth]="true" [icon]="'ICON.' + (item.ds_type_uid || 'UNKNOWN') | translate"></fa-icon>
                  {{ item.name || item.ds_name }} 
              </span>
          
            </div>

            <div class="clearfix"></div>

        </li>

      </ng-container>

    </ng-container>
    
  </ul>
  
  <xs-widget-popover [pluginController]="transformPlugins" [context]="this"></xs-widget-popover>
  
</div>

<!-- <div id="legend-show-layers" *ngIf="sceneTransformsActive && sceneTransformsActive.length"></div> -->